function initWizzyCustom() {
  if (window._wizzyCustomInitialized) return;
  window._wizzyCustomInitialized = true;

var colorMap = new Map([
  ['Rust', ['#b7410e', false]],
  ['Multicolor', ['https://i.ibb.co/BVjj74X/classic-color-spectrum-rgb-line-gradient-vector-522680-173-copy.png', true]],
  ['Multi', ['https://i.ibb.co/BVjj74X/classic-color-spectrum-rgb-line-gradient-vector-522680-173-copy.png', true]],
  ['Peach', ['#ffdab9', false]],
  ['Golden', ['#ffd900', false]],
  ['Off-White', ['#f5f5f5', false]],
  ['Cream', ['#fffdd0', false]],
  ['Sky Blue', ['#87CEEB', false]],
  ['Navy Blue', ['#000080', false]],
  ['Light Blue', ['#ADD8E6', false]],
  ['Olive Green', ['#556B2F', false]],
  ['Light Green', ['#90EE90', false]],
  ['Dark Grey', ['#A9A9A9', false]],
  ['Dark Blue', ['#00008B', false]],
  ['Jet Black', ['#000000', false]],
  ['Bright White', ['#FFFFFF', false]],
  ['Light Grey', ['#D3D3D3', false]],
  ['Wine', ['#722F37', false]],
  ['Teal Blue', ['#008080', false]],
  ['Royal Blue', ['#4169E1', false]],
  ['Indigo Blue', ['#4B0082', false]],
  ['Mid Blue', ['#0000CD', false]],
  ['Peacock Blue', ['#006994', false]],
  ['Deep Blue', ['#000080', false]],
  ['Aqua Blue', ['#00FFFF', false]],
  ['Ice Blue', ['#BCE6E6', false]],
  ['Night Blue', ['#191970', false]],
  ['Denim Blue', ['#1560BD', false]],
  ['Turquoise Blue', ['#40E0D0', false]],
  ['Brick Red', ['#B22222', false]],
  ['Light Red', ['#FF6961', false]],
  ['Dark Red', ['#8B0000', false]],
  ['Bright Red', ['#FF0000', false]],
  ['Carrot red', ['#FF4500', false]],
  ['Burn Red', ['#9A3334', false]],
  ['Cardinal Red', ['#C41E3A', false]],
  ['Oxblood Red', ['#800020', false]],
  ['Rio Red', ['#DA2C43', false]],
  ['Rose Red', ['#FF033E', false]],
  ['Rumba Red', ['#C76E70', false]],
  ['Spice Red', ['#A23C3C', false]],
  ['Tango Red', ['#E25822', false]],
  ['Deep Red', ['#8B0000', false]],
  ['Mustard Yellow', ['#FFDB58', false]],
  ['Light Yellow', ['#FFFFE0', false]],
  ['Lemon Yellow', ['#FFF44F', false]],
  ['Mellow Yellow', ['#F8DE7E', false]],
  ['Bright Yellow', ['#FFFF00', false]],
  ['Golden Yellow', ['#FFD700', false]],
  ['Chrome Yellow', ['#FFA700', false]],
  ['Corn Yellow', ['#FBEC5D', false]],
  ['Musturd Yellow', ['#FFDB58', false]],
  ['Pale Yellow', ['#EEE8AA', false]],
  ['Pastel Yellow', ['#FDFD96', false]],
  ['Taffy Yellow', ['#F8DE7E', false]],
  ['Dark Green', ['#006400', false]],
  ['Light Pink', ['#FFB6C1', false]],
  ['Onion Pink', ['#F5B9F5', false]],
  ['Island Pink', ['#FFD1DC', false]],
  ['Lilac Pink', ['#FFC0CB', false]],
  ['Rose Pink', ['#FF66CC', false]],
  ['Coral Pink', ['#FF7F50', false]],
  ['Dusty Pink', ['#D8BFD8', false]],
  ['Send Pink', ['#FF91A4', false]],
  ['Blossom Pink', ['#FFC3A0', false]],
  ['Delicacy Pink', ['#FEC3AC', false]],
  ['Flamingo Pink', ['#FC8EAC', false]],
  ['Pastel Pink', ['#FFD1BB', false]],
  ['Baby Pink', ['#FFC0CB', false]],
  ['Pastel Purple', ['#B39EB5', false]],
  ['Dark Purple', ['#800080', false]],
  ['Beige', ['#F5F5DC', false]],
  ['Light Purple', ['#E6E6FA', false]],
  ['Cloud Cream', ['#FFF8E7', false]],
  ['Custard Cream', ['#FFF0C1', false]],
  ['Dark Cream', ['#EEE8AA', false]],
  ['Dawn Cream', ['#FFFAF0', false]],
  ['Fawn Cream', ['#E5AA70', false]],
  ['Italian Cream', ['#F6ECD8', false]],
  ['Light Orange', ['#FFD68F', false]],
  ['Apricot Orange', ['#FDD5B1', false]],
  ['Bright Orange', ['#FF8C00', false]],
  ['Burnt Orange', ['#FF4500', false]],
  ['Coral Orange', ['#FF7F50', false]],
  ['Golden Orange', ['#FFD700', false]],
  ['Dark Olive', ['#556B2F', false]],
  ['Olive Brown', ['#806517', false]],
  ['Light Olive', ['#AAB300', false]],
  ['Olive Grey', ['#B5B35C', false]],
  ['Branch Olive', ['#5F6527', false]],
  ['Dark Olive Green', ['#556B2F', false]],
  ['Deep Olive Green', ['#556B2F', false]],
  ['Dusty Olive', ['#8A8662', false]],
  ['Olive Melange', ['#6B6C4A', false]],
  ['Dark Maroon', ['#800000', false]],
  ['Maroon gold', ['#B03060', false]],
  ['Silver Grey', ['#C0C0C0', false]],
  ['Lime Green', ['#00FF00', false]],
  ['State Gray', ['#808080', false]],
  ['Teal Green', ['#008080', false]],
  ['Dusty Teal', ['#4e5d4e', false]],
  ['Teal Black', ['#003838', false]],
  ['Teal Grey', ['#69838d', false]],
  ['Midnight Navy', ['#000080', false]],
  ['Grey Melange', ['#808080', false]],
  ['Charcoal Grey', ['#36454F', false]],
  ['Ercus Melange', ['#B5B5B5', false]],
  ['Air Force Blue', ['#5D8AA8', false]],
  ['Aquamarine Blue', ['#7FFFD4', false]],
  ['Carrot Brown', ['#ED9121', false]],
  ['Colonial Blue', ['#002F6C', false]],
  ['Cornet Blue', ['#6495ED', false]],
  ['Deep Wine', ['#8B0000', false]],
  ['Bottle Green', ['#092E20', false]],

  // Newly added missing colors from the list
  ['Anthracite', ['#293133', false]],
  ['Black', ['#000000', false]],
  ['Black Khaki Bl', ['#2B2B24', false]],
  ['Black Leather', ['#1A1A1A', false]],
  ['Black Nubuck', ['#212121', false]],
  ['Black Suede', ['#1C1C1C', false]],
  ['Blue', ['#0000FF', false]],
  ['Bronze Pink Met', ['#B07C7C', false]],
  ['Brown', ['#A52A2A', false]],
  ['Chalk', ['#F6F4F1', false]],
  ['Champagne', ['#F7E7CE', false]],
  ['Clear Sky Met', ['#8CB0CF', false]],
  ['Dark Flwr Stamp', ['#3A2E3B', false]],
  ['Dungaree Blue', ['#566F87', false]],
  ['Escape Red', ['#CC1100', false]],
  ['Flower Stamp', ['#E8A2B5', false]],
  ['Game Grey', ['#78808A', false]],
  ['Green', ['#008000', false]],
  ['Grey', ['#808080', false]],
  ['Intense Rose', ['#B93A6F', false]],
  ['Linen', ['#FAF0E6', false]],
  ['Medium Blue', ['#4B89DC', false]],
  ['Multicolour', ['https://i.ibb.co/BVjj74X/classic-color-spectrum-rgb-line-gradient-vector-522680-173-copy.png', true]],
  ['Natural White', ['#F8F6F0', false]],
  ['Navy', ['#000080', false]],
  ['NAVY BLUE', ['#000080', false]],
  ['Navy Leather', ['#1B263B', false]],
  ['Navy Nubuck', ['#2C3E50', false]],
  ['Orange', ['#FFA500', false]],
  ['Pink', ['#FFC0CB', false]],
  ['PINK', ['#FFC0CB', false]],
  ['Purple', ['#800080', false]],
  ['Red', ['#FF0000', false]],
  ['RED', ['#FF0000', false]],
  ['Silver', ['#C0C0C0', false]],
  ['Snow', ['#FAFAFA', false]],
  ['Soccer Prt', ['#E0E0E0', false]],
  ['Tan Leather', ['#B68A5D', false]],
  ['White', ['#FFFFFF', false]],
  ['Yellow', ['#FFFF00', false]],
  ['Gold', ['#FFD700'], false]
]);

function findHaxCode(key) {
  if (colorMap.has(key)) {
    return colorMap.get(key);
  }
  return [key, false];
}

var WIZZY_ARABIC_COLOR_LABELS = {
  'Rust': 'صدأ',
  'Multicolor': 'متعدد الألوان',
  'Multi': 'متعدد الألوان',
  'Multicolour': 'متعدد الألوان',
  'Peach': 'خوخي',
  'Golden': 'ذهبي',
  'Off-White': 'أبيض عاجي',
  'Cream': 'كريمي',
  'Sky Blue': 'أزرق سماوي',
  'Navy Blue': 'أزرق كحلي',
  'NAVY BLUE': 'أزرق كحلي',
  'Light Blue': 'أزرق فاتح',
  'Olive Green': 'أخضر زيتوني',
  'Light Green': 'أخضر فاتح',
  'Dark Grey': 'رمادي داكن',
  'Dark Blue': 'أزرق داكن',
  'Jet Black': 'أسود فاحم',
  'Bright White': 'أبيض ناصع',
  'Light Grey': 'رمادي فاتح',
  'Wine': 'نبيذي',
  'Teal Blue': 'أزرق مخضر',
  'Royal Blue': 'أزرق ملكي',
  'Indigo Blue': 'أزرق نيلي',
  'Mid Blue': 'أزرق متوسط',
  'Peacock Blue': 'أزرق طاووسي',
  'Deep Blue': 'أزرق عميق',
  'Aqua Blue': 'أزرق مائي',
  'Ice Blue': 'أزرق جليدي',
  'Night Blue': 'أزرق ليلي',
  'Denim Blue': 'أزرق جينز',
  'Turquoise Blue': 'أزرق فيروزي',
  'Brick Red': 'أحمر طوبي',
  'Light Red': 'أحمر فاتح',
  'Dark Red': 'أحمر داكن',
  'Bright Red': 'أحمر ساطع',
  'Carrot red': 'أحمر جزر',
  'Burn Red': 'أحمر محروق',
  'Cardinal Red': 'أحمر قرمزي',
  'Oxblood Red': 'أحمر دموي',
  'Rio Red': 'أحمر ريو',
  'Rose Red': 'أحمر وردي',
  'Rumba Red': 'أحمر رومبا',
  'Spice Red': 'أحمر توابل',
  'Tango Red': 'أحمر تانجو',
  'Deep Red': 'أحمر عميق',
  'Mustard Yellow': 'أصفر خردلي',
  'Musturd Yellow': 'أصفر خردلي',
  'Light Yellow': 'أصفر فاتح',
  'Lemon Yellow': 'أصفر ليموني',
  'Mellow Yellow': 'أصفر هادئ',
  'Bright Yellow': 'أصفر ساطع',
  'Golden Yellow': 'أصفر ذهبي',
  'Chrome Yellow': 'أصفر كروم',
  'Corn Yellow': 'أصفر ذرة',
  'Pale Yellow': 'أصفر باهت',
  'Pastel Yellow': 'أصفر باستيل',
  'Taffy Yellow': 'أصفر تافي',
  'Dark Green': 'أخضر داكن',
  'Light Pink': 'وردي فاتح',
  'Onion Pink': 'وردي بصل',
  'Island Pink': 'وردي جزيرة',
  'Lilac Pink': 'وردي ليلك',
  'Rose Pink': 'وردي ورد',
  'Coral Pink': 'وردي مرجاني',
  'Dusty Pink': 'وردي ترابي',
  'Send Pink': 'وردي',
  'Blossom Pink': 'وردي زهر',
  'Delicacy Pink': 'وردي رقيق',
  'Flamingo Pink': 'وردي فلامنجو',
  'Pastel Pink': 'وردي باستيل',
  'Baby Pink': 'وردي بيبي',
  'Pastel Purple': 'بنفسجي باستيل',
  'Dark Purple': 'بنفسجي داكن',
  'Beige': 'بيج',
  'Light Purple': 'بنفسجي فاتح',
  'Cloud Cream': 'كريمي سحاب',
  'Custard Cream': 'كريمي كسترد',
  'Dark Cream': 'كريمي داكن',
  'Dawn Cream': 'كريمي فجر',
  'Fawn Cream': 'كريمي ظبي',
  'Italian Cream': 'كريمي إيطالي',
  'Light Orange': 'برتقالي فاتح',
  'Apricot Orange': 'برتقالي مشمش',
  'Bright Orange': 'برتقالي ساطع',
  'Burnt Orange': 'برتقالي محروق',
  'Coral Orange': 'برتقالي مرجاني',
  'Golden Orange': 'برتقالي ذهبي',
  'Dark Olive': 'زيتوني داكن',
  'Olive Brown': 'بني زيتوني',
  'Light Olive': 'زيتوني فاتح',
  'Olive Grey': 'رمادي زيتوني',
  'Branch Olive': 'زيتوني غصن',
  'Dark Olive Green': 'أخضر زيتوني داكن',
  'Deep Olive Green': 'أخضر زيتوني عميق',
  'Dusty Olive': 'زيتوني ترابي',
  'Olive Melange': 'زيتوني ميلانج',
  'Dark Maroon': 'كستنائي داكن',
  'Maroon gold': 'كستنائي ذهبي',
  'Silver Grey': 'رمادي فضي',
  'Lime Green': 'أخضر ليموني',
  'State Gray': 'رمادي',
  'Teal Green': 'أخضر مخضر',
  'Dusty Teal': 'مخضر ترابي',
  'Teal Black': 'أسود مخضر',
  'Teal Grey': 'رمادي مخضر',
  'Midnight Navy': 'كحلي منتصف الليل',
  'Grey Melange': 'رمادي ميلانج',
  'Charcoal Grey': 'رمادي فحمي',
  'Ercus Melange': 'رمادي ميلانج',
  'Air Force Blue': 'أزرق جوي',
  'Aquamarine Blue': 'أزرق aquamarine',
  'Carrot Brown': 'بني جزر',
  'Colonial Blue': 'أزرق colonial',
  'Cornet Blue': 'أزرق cornet',
  'Deep Wine': 'نبيذي عميق',
  'Bottle Green': 'أخضر زجاجة',
  'Anthracite': 'أنثراسite',
  'Black': 'أسود',
  'Black Khaki Bl': 'أسود كاكي',
  'Black Leather': 'أسود جلد',
  'Black Nubuck': 'أسود nubuck',
  'Black Suede': 'أسود suede',
  'Blue': 'أزرق',
  'Bronze Pink Met': 'وردي برونزي',
  'Brown': 'بني',
  'Chalk': 'طباشير',
  'Champagne': 'شامبانيا',
  'Clear Sky Met': 'سماء صافية',
  'Dark Flwr Stamp': 'زهري داكن',
  'Dungaree Blue': 'أزرق دنim',
  'Escape Red': 'أحمر escape',
  'Flower Stamp': 'زهري',
  'Game Grey': 'رمادي game',
  'Green': 'أخضر',
  'Grey': 'رمادي',
  'Intense Rose': 'وردي intense',
  'Linen': 'كتان',
  'Medium Blue': 'أزرق متوسط',
  'Natural White': 'أبيض طبيعي',
  'Navy': 'كحلي',
  'Navy Leather': 'كحلي جلد',
  'Navy Nubuck': 'كحلي nubuck',
  'Orange': 'برتقالي',
  'Pink': 'وردي',
  'PINK': 'وردي',
  'Purple': 'بنفسجي',
  'Red': 'أحمر',
  'RED': 'أحمر',
  'Silver': 'فضي',
  'Snow': 'ثلجي',
  'Soccer Prt': 'رمادي soccer',
  'Tan Leather': 'أسمر جلد',
  'White': 'أبيض',
  'Yellow': 'أصفر'
};

var arabicColorMap = new Map();
colorMap.forEach(function (value, key) {
  arabicColorMap.set(key, [value[0], value[1], WIZZY_ARABIC_COLOR_LABELS[key] || null]);
});

window.arabicColorMap = arabicColorMap;
window.WIZZY_ARABIC_COLOR_LABELS = WIZZY_ARABIC_COLOR_LABELS;

function findArabicColorMapKey(key) {
  if (!key) return null;
  if (arabicColorMap.has(key)) return key;

  var normalized = String(key).trim().toLowerCase();
  var found = null;

  arabicColorMap.forEach(function (unused, mapKey) {
    if (!found && String(mapKey).trim().toLowerCase() === normalized) {
      found = mapKey;
    }
  });

  return found;
}

function findArabicColorEntry(key) {
  var mapKey = findArabicColorMapKey(key);
  if (mapKey && arabicColorMap.has(mapKey)) {
    return arabicColorMap.get(mapKey);
  }

  var color = findHaxCode(key);
  return [color[0], color[1], null];
}

function resolveArabicColorLabel(enValue) {
  if (!enValue || !isWizzyArabicStoreContext()) return null;

  var mapKey = findArabicColorMapKey(enValue);
  if (!mapKey || !arabicColorMap.has(mapKey)) return null;

  var entry = arabicColorMap.get(mapKey);
  return entry && entry[2] ? entry[2] : null;
}

function buildStarsHtml(avgRating) {
  var rating = parseFloat(avgRating);
  if (isNaN(rating) || rating <= 0) {
    return '★★★★★';
  }
  var full = Math.floor(rating);
  var half = rating - full >= 0.3;
  var stars = '';
  var i;
  for (i = 0; i < 5; i++) {
    if (i < full) {
      stars += '★';
    } else if (i === full && half) {
      stars += '★';
    } else {
      stars += '☆';
    }
  }
  return stars;
}

var WIZZY_ARABIC_STORE_ID = 'd582a464874c11f1bbbd0a0c8095feae';

var WIZZY_ARABIC_UI_LABELS = {
  storeId: WIZZY_ARABIC_STORE_ID,
  static: {
    sort: 'ترتيب',
    sortBy: 'ترتيب حسب',
    filter: 'تصفية',
    filters: 'تصفية',
    showFilters: 'إظهار التصفية',
    hideFilters: 'إخفاء التصفية',
    applyFilters: 'تطبيق التصفية',
    showResults: 'عرض النتائج',
    clear: 'مسح',
    clearAll: 'مسح الكل',
    loadMore: 'تحميل المزيد',
    backToProducts: 'العودة إلى المنتجات'
  },
  sort: [
    { type: 'static', field: 'relevance', order: 'desc', en: 'Relevance', ar: 'الأكثر صلة' },
    { type: 'static', field: 'relevance', order: 'asc', en: 'Relevance', ar: 'الأكثر صلة' },
    { type: 'static', en: 'Most relevant', ar: 'الأكثر صلة' },
    { type: 'static', en: 'Featured', ar: 'مميز' },
    { type: 'static', field: 'sellingPrice', order: 'asc', en: 'Price: Low - High', ar: 'السعر: من الأقل إلى الأعلى' },
    { type: 'static', field: 'sellingPrice', order: 'desc', en: 'Price: High - Low', ar: 'السعر: من الأعلى إلى الأقل' },
    { type: 'static', en: 'Price: Low - High', ar: 'السعر: من الأقل إلى الأعلى' },
    { type: 'static', en: 'Price: High - Low', ar: 'السعر: من الأعلى إلى الأقل' },
    { type: 'static', field: 'createdAt', order: 'desc', en: 'New Arrivals', ar: 'وصول جديد' },
    { type: 'static', en: 'Newest', ar: 'الأحدث' },
    { type: 'static', field: 'bestSelling', order: 'desc', en: 'Best Selling', ar: 'الأكثر مبيعًا' },
    { type: 'static', en: 'Best Selling', ar: 'الأكثر مبيعًا' }
  ],
  filters: [
    { type: 'static', key: 'brands', en: 'Brand', ar: 'العلامة التجارية' },
    { type: 'static', key: 'brand', en: 'Brand', ar: 'العلامة التجارية' },
    { type: 'static', key: 'sizes', en: 'Size', ar: 'المقاس' },
    { type: 'static', key: 'size', en: 'Size', ar: 'المقاس' },
    { type: 'static', key: 'colors', en: 'Color', ar: 'اللون' },
    { type: 'static', key: 'colours', en: 'Colour', ar: 'اللون' },
    { type: 'static', key: 'sellingPrice', en: 'Price', ar: 'السعر' },
    { type: 'static', key: 'price', en: 'Price', ar: 'السعر' },
    { type: 'static', key: 'categories', en: 'Category', ar: 'الفئة' },
    { type: 'static', key: 'productType', en: 'Product Type', ar: 'نوع المنتج' },
    { type: 'static', key: 'gender', en: 'Gender', ar: 'الجنس' },
    { type: 'static', key: 'genders', en: 'Gender', ar: 'الجنس' },
    { type: 'static', en: 'Gender', ar: 'الجنس' },
    { type: 'static', en: 'Refine by Brand', ar: 'تصفية حسب العلامة التجارية' },
    { type: 'static', en: 'Filters', ar: 'تصفية' }
  ],
  gender: [
    { type: 'static', en: 'Men', ar: 'رجال' },
    { type: 'static', en: 'Man', ar: 'رجال' },
    { type: 'static', en: 'Male', ar: 'رجال' },
    { type: 'static', en: 'Women', ar: 'نساء' },
    { type: 'static', en: 'Woman', ar: 'نساء' },
    { type: 'static', en: 'Female', ar: 'نساء' },
    { type: 'static', en: 'Kids', ar: 'أطفال' },
    { type: 'static', en: 'Kid', ar: 'أطفال' },
    { type: 'static', en: 'Children', ar: 'أطفال' },
    { type: 'static', en: 'Boys', ar: 'أولاد' },
    { type: 'static', en: 'Boy', ar: 'ولد' },
    { type: 'static', en: 'Girls', ar: 'بنات' },
    { type: 'static', en: 'Girl', ar: 'بنت' },
    { type: 'static', en: 'Baby', ar: 'رضع' },
    { type: 'static', en: 'Unisex', ar: 'للجنسين' }
  ],
  dynamic: {
    sort: [],
    filters: [],
    filterValues: [],
    gender: []
  }
};

window.WIZZY_ARABIC_UI_LABELS = WIZZY_ARABIC_UI_LABELS;

function normalizeWizzyEnLabel(value) {
  return String(value || '').trim().toLowerCase();
}

function isWizzyArabicStoreContext() {
  if (!isArabicLocale()) return false;
  var creds = window.wizzyConfig && window.wizzyConfig.credentials;
  return !!(creds && creds.storeId === WIZZY_ARABIC_STORE_ID);
}

function containsArabicScript(value) {
  return /[\u0600-\u06FF]/.test(String(value || ''));
}

function splitWizzyEnArLabels(fields, fallbackEn) {
  var en = null;
  var ar = null;
  var i;
  var val;

  for (i = 0; i < fields.length; i++) {
    val = fields[i];
    if (val === null || val === undefined) continue;
    val = String(val).trim();
    if (!val) continue;
    if (containsArabicScript(val)) {
      if (!ar) ar = val;
    } else if (!en) {
      en = val;
    }
  }

  if (!en && fallbackEn) en = String(fallbackEn).trim();
  return { en: en || null, ar: ar || null };
}

function extractWizzyFacetBlockLabels(facet) {
  if (!facet) return { en: null, ar: null };

  var fields = [
    facet.title, facet.label, facet.name, facet.displayLabel,
    facet.arTitle, facet.titleAr, facet.arabicTitle, facet.translatedTitle, facet.localizedLabel
  ];

  if (facet.translations) {
    if (facet.translations.ar) fields.push(facet.translations.ar);
    if (facet.translations.arabic) fields.push(facet.translations.arabic);
  }

  return splitWizzyEnArLabels(fields, facet.key);
}

function extractWizzyFacetItemLabels(item) {
  if (!item) return { en: null, ar: null };

  var fields = [
    item.label, item.name, item.title, item.displayLabel,
    item.arLabel, item.labelAr, item.arabicLabel, item.translatedLabel, item.localizedLabel
  ];

  if (item.data && item.data.label) fields.push(item.data.label);
  if (item.translations) {
    if (item.translations.ar) fields.push(item.translations.ar);
    if (item.translations.arabic) fields.push(item.translations.arabic);
  }

  return splitWizzyEnArLabels(fields, item.key);
}

function findDynamicArabicFilterEntry(facetKey, enValue) {
  var dynamicFilters = WIZZY_ARABIC_UI_LABELS.dynamic.filters;
  var i;
  var entry;

  for (i = 0; i < dynamicFilters.length; i++) {
    entry = dynamicFilters[i];
    if (facetKey && entry.key === facetKey) return entry;
    if (enValue && entry.en && normalizeWizzyEnLabel(entry.en) === normalizeWizzyEnLabel(enValue)) return entry;
  }

  return null;
}

function findDynamicArabicFilterValueEntry(facetKey, itemKey, enValue) {
  var dynamicValues = WIZZY_ARABIC_UI_LABELS.dynamic.filterValues;
  var i;
  var entry;

  for (i = 0; i < dynamicValues.length; i++) {
    entry = dynamicValues[i];
    if (facetKey && itemKey && entry.facetKey === facetKey && entry.key === itemKey) return entry;
    if (facetKey && entry.facetKey === facetKey && enValue &&
      normalizeWizzyEnLabel(entry.en) === normalizeWizzyEnLabel(enValue)) return entry;
    if (itemKey && entry.key === itemKey) return entry;
    if (enValue && entry.en && normalizeWizzyEnLabel(entry.en) === normalizeWizzyEnLabel(enValue)) return entry;
  }

  return null;
}

function registerDynamicArabicSort(sortItem) {
  if (!sortItem) return;

  var labels = splitWizzyEnArLabels([
    sortItem.label, sortItem.name, sortItem.title,
    sortItem.arLabel, sortItem.labelAr, sortItem.displayLabel
  ], null);
  var enLabel = labels.en || sortItem.label || sortItem.name || sortItem.title;
  if (!enLabel) return;

  var arLabel = labels.ar || resolveArabicSortLabel(sortItem);
  var dynamicSort = WIZZY_ARABIC_UI_LABELS.dynamic.sort;
  var i;
  var entry;

  for (i = 0; i < dynamicSort.length; i++) {
    entry = dynamicSort[i];
    if (sortItem.field && entry.field === sortItem.field && entry.order === sortItem.order) {
      if (enLabel) entry.en = enLabel;
      if (arLabel) entry.ar = arLabel;
      return;
    }
    if (normalizeWizzyEnLabel(entry.en) === normalizeWizzyEnLabel(enLabel)) {
      if (arLabel) entry.ar = arLabel;
      return;
    }
  }

  dynamicSort.push({
    type: 'dynamic',
    field: sortItem.field || null,
    order: sortItem.order || null,
    en: enLabel,
    ar: arLabel || null
  });
}

function registerDynamicArabicFilter(facet) {
  if (!facet) return;

  var labels = extractWizzyFacetBlockLabels(facet);
  var enTitle = labels.en || facet.title || facet.label || facet.name;
  if (!enTitle) return;

  var arTitle = labels.ar || resolveArabicFilterTitle(facet);
  var existing = findDynamicArabicFilterEntry(facet.key, enTitle);

  if (existing) {
    if (enTitle) existing.en = enTitle;
    if (arTitle) existing.ar = arTitle;
    if (facet.key) existing.key = facet.key;
    return;
  }

  WIZZY_ARABIC_UI_LABELS.dynamic.filters.push({
    type: 'dynamic',
    key: facet.key || null,
    en: enTitle,
    ar: arTitle || null
  });
}

function resolveArabicSortLabel(sortItem) {
  if (!sortItem) return null;

  var enLabel = sortItem.label || sortItem.name || sortItem.title;
  var collections = [WIZZY_ARABIC_UI_LABELS.sort, WIZZY_ARABIC_UI_LABELS.dynamic.sort];
  var i;
  var entry;

  for (i = 0; i < collections.length; i++) {
    for (var j = 0; j < collections[i].length; j++) {
      entry = collections[i][j];
      if (sortItem.field && entry.field === sortItem.field && (!entry.order || entry.order === sortItem.order) && entry.ar) {
        return entry.ar;
      }
      if (enLabel && entry.en && normalizeWizzyEnLabel(entry.en) === normalizeWizzyEnLabel(enLabel) && entry.ar) {
        return entry.ar;
      }
    }
  }

  return null;
}

function resolveArabicFilterTitle(facet) {
  if (!facet) return null;

  var blockLabels = extractWizzyFacetBlockLabels(facet);
  if (blockLabels.ar) return blockLabels.ar;

  var enTitle = blockLabels.en || facet.title || facet.label || facet.name;
  var collections = [WIZZY_ARABIC_UI_LABELS.dynamic.filters, WIZZY_ARABIC_UI_LABELS.filters];
  var i;
  var entry;

  for (i = 0; i < collections.length; i++) {
    for (var j = 0; j < collections[i].length; j++) {
      entry = collections[i][j];
      if (facet.key && entry.key && entry.key === facet.key && entry.ar) {
        return entry.ar;
      }
      if (enTitle && entry.en && normalizeWizzyEnLabel(entry.en) === normalizeWizzyEnLabel(enTitle) && entry.ar) {
        return entry.ar;
      }
    }
  }

  return null;
}

function normalizeWizzyFacetKey(key) {
  return String(key || '').trim().toLowerCase();
}

function isWizzyColorFacetKey(facetKey) {
  var key = normalizeWizzyFacetKey(facetKey);
  return key === 'colors' || key === 'colours' || key.indexOf('color') > -1 || key.indexOf('colour') > -1;
}

function isWizzyGenderFacetKey(facetKey) {
  var key = normalizeWizzyFacetKey(facetKey);
  return key === 'gender' || key === 'genders' || key.indexOf('gender') > -1;
}

function isWizzySizeFacetKey(facetKey) {
  var key = normalizeWizzyFacetKey(facetKey);
  return key === 'size' || key === 'sizes' || key.indexOf('size') > -1;
}

function getWizzySizeEnglishLabel(item) {
  if (!item) return '';

  var directLabel = item.label || item.name || item.title;
  if (directLabel && String(directLabel).trim()) {
    return String(directLabel).trim();
  }

  if (item.key) return String(item.key).trim();

  if (item.data && item.data.value) {
    return String(item.data.value).trim();
  }

  var labels = extractWizzyFacetItemLabels(item);
  return labels.en || labels.ar || '';
}

function applyWizzySizeLabelToDomItem(domItem, displayLabel) {
  if (!domItem || !displayLabel) return;

  domItem.classList.remove('facet-has-swatch');

  var swatchWrapper = domItem.querySelector('.wizzy-facet-item-swatch-wrapper');
  if (swatchWrapper) swatchWrapper.style.display = 'none';

  var labelEl = domItem.querySelector('.facet-item-label-value');
  if (!labelEl) {
    var parent = domItem.querySelector('.wizzy-facet-list-item-label');
    if (parent) {
      labelEl = document.createElement('span');
      labelEl.className = 'facet-item-label-value';
      parent.appendChild(labelEl);
    }
  }

  if (labelEl) labelEl.textContent = displayLabel;
}

function stripWizzySizeFacetSwatchFlags(item) {
  if (!item) return;
  item.isSwatch = false;
  item.isURLSwatch = false;
  item.isVisualSwatch = false;
}

function ensureWizzySizeFacetEnglishLabels(facet) {
  if (!facet || !isWizzySizeFacetKey(facet.key) || !Array.isArray(facet.data)) return;

  facet.data.forEach(function (item) {
    if (isWizzyArabicStoreContext()) {
      registerDynamicArabicFilterValue(facet.key, item);
    }

    var displayLabel = getWizzySizeEnglishLabel(item);
    if (displayLabel) {
      item.label = displayLabel;
      if (item.name) item.name = displayLabel;
      if (item.title) item.title = displayLabel;
    }

    stripWizzySizeFacetSwatchFlags(item);
  });
}

function getWizzyApiFacetsFromPageStore() {
  var pageStore = window.wizzyConfig && window.wizzyConfig.pageStore;
  var searched = pageStore && pageStore.searchedResponse;
  return searched && Array.isArray(searched.facets) ? searched.facets : null;
}

function syncSizeFacetLabelsFromApi() {
  var facets = getWizzyApiFacetsFromPageStore();
  var sizeFacetMap = {};

  if (facets) {
    facets.forEach(function (facet) {
      if (!isWizzySizeFacetKey(facet.key) || !Array.isArray(facet.data)) return;
      sizeFacetMap[facet.key] = facet;
    });
  }

  document.querySelectorAll(
    '.wizzy-filters-facet-block.facet-block-sizes,' +
    '.wizzy-grid-filters-box.facet-block-sizes,' +
    '.wizzy-filters-facet-block[data-key="sizes"],' +
    '.wizzy-filters-facet-block[data-key="size"],' +
    '.wizzy-grid-filters-box[data-key="sizes"],' +
    '.wizzy-grid-filters-box[data-key="size"]'
  ).forEach(function (block) {
    var facetKey = block.getAttribute('data-key');
    var facet = facetKey ? sizeFacetMap[facetKey] : null;

    block.querySelectorAll('.wizzy-facet-list-item[data-key]').forEach(function (domItem) {
      var itemKey = domItem.getAttribute('data-key');
      if (!itemKey) return;

      var apiItem = null;
      if (facet && facet.data) {
        for (var i = 0; i < facet.data.length; i++) {
          if (facet.data[i].key === itemKey) {
            apiItem = facet.data[i];
            break;
          }
        }
      }

      var displayLabel = apiItem ? getWizzySizeEnglishLabel(apiItem) : itemKey;
      applyWizzySizeLabelToDomItem(domItem, displayLabel);
    });
  });
}

function applyWizzySizeFacetLabelFixes(data) {
  if (!data || !data.response) return data;
  if (data.api !== 'search' && data.api !== 'filter') return data;

  var payload = data.response.payload;
  if (payload && Array.isArray(payload.facets)) {
    payload.facets.forEach(function (facet) {
      if (isWizzySizeFacetKey(facet.key)) {
        // ensureWizzySizeFacetEnglishLabels(facet);
      }
    });
  }

  return data;
}

function findDynamicArabicGenderEntry(itemKey, enValue) {
  var dynamicGender = WIZZY_ARABIC_UI_LABELS.dynamic.gender;
  var i;
  var entry;

  for (i = 0; i < dynamicGender.length; i++) {
    entry = dynamicGender[i];
    if (itemKey && entry.key === itemKey) return entry;
    if (enValue && entry.en && normalizeWizzyEnLabel(entry.en) === normalizeWizzyEnLabel(enValue)) return entry;
  }

  return null;
}

function resolveArabicGenderValue(enValue) {
  if (!enValue) return null;

  var collections = [WIZZY_ARABIC_UI_LABELS.gender, WIZZY_ARABIC_UI_LABELS.dynamic.gender];
  var i;
  var j;
  var entry;

  for (i = 0; i < collections.length; i++) {
    for (j = 0; j < collections[i].length; j++) {
      entry = collections[i][j];
      if (entry.en && normalizeWizzyEnLabel(entry.en) === normalizeWizzyEnLabel(enValue) && entry.ar) {
        return entry.ar;
      }
      if (entry.key && normalizeWizzyEnLabel(entry.key) === normalizeWizzyEnLabel(enValue) && entry.ar) {
        return entry.ar;
      }
    }
  }

  return null;
}

function registerDynamicArabicGenderValue(facetKey, item, labels) {
  if (!isWizzyGenderFacetKey(facetKey) || !item) return;

  var itemKey = item.key || (labels && labels.en);
  var enValue = (labels && labels.en) || itemKey;
  if (!enValue && !itemKey) return;

  var arValue = (labels && labels.ar) || resolveArabicGenderValue(enValue || itemKey);
  var existing = findDynamicArabicGenderEntry(itemKey, enValue);

  if (existing) {
    if (enValue) existing.en = enValue;
    if (itemKey) existing.key = itemKey;
    if (arValue) existing.ar = arValue;
    if (item.label) existing.apiLabel = item.label;
    return;
  }

  WIZZY_ARABIC_UI_LABELS.dynamic.gender.push({
    type: 'dynamic',
    facetKey: facetKey || null,
    key: itemKey,
    en: enValue,
    ar: arValue || null,
    apiLabel: item.label || null
  });
}

function registerDynamicArabicFilterValue(facetKey, item) {
  if (!item) return;

  var labels = extractWizzyFacetItemLabels(item);
  var itemKey = item.key || labels.en;
  var enValue = labels.en || itemKey;
  if (!enValue && !itemKey) return;

  var arValue = labels.ar || null;
  if (!arValue && isWizzyGenderFacetKey(facetKey)) {
    arValue = resolveArabicGenderValue(enValue || itemKey);
  }
  if (!arValue && isWizzyColorFacetKey(facetKey)) {
    arValue = resolveArabicColorLabel(enValue || itemKey);
  }

  registerDynamicArabicGenderValue(facetKey, item, labels);

  var existing = findDynamicArabicFilterValueEntry(facetKey, itemKey, enValue);

  if (existing) {
    if (enValue) existing.en = enValue;
    if (itemKey) existing.key = itemKey;
    if (facetKey) existing.facetKey = facetKey;
    if (arValue) existing.ar = arValue;
    if (item.label) existing.apiLabel = item.label;
    return;
  }

  WIZZY_ARABIC_UI_LABELS.dynamic.filterValues.push({
    type: 'dynamic',
    facetKey: facetKey || null,
    key: itemKey,
    en: enValue,
    ar: arValue,
    apiLabel: item.label || null
  });
}

function resolveArabicFilterValue(facetKey, enValue) {
  if (!enValue) return null;

  var arValue;
  var dynamicValues = WIZZY_ARABIC_UI_LABELS.dynamic.filterValues;
  var i;
  var entry;

  if (isWizzyGenderFacetKey(facetKey)) {
    arValue = resolveArabicGenderValue(enValue);
    if (arValue) return arValue;
  }

  if (isWizzyColorFacetKey(facetKey)) {
    arValue = resolveArabicColorLabel(enValue);
    if (arValue) return arValue;
  }

  for (i = 0; i < dynamicValues.length; i++) {
    entry = dynamicValues[i];
    if (!entry.ar) continue;
    if (facetKey && entry.facetKey === facetKey &&
      (entry.key === enValue || (entry.en && normalizeWizzyEnLabel(entry.en) === normalizeWizzyEnLabel(enValue)))) {
      return entry.ar;
    }
    if (entry.key && entry.key === enValue) return entry.ar;
    if (entry.en && normalizeWizzyEnLabel(entry.en) === normalizeWizzyEnLabel(enValue)) return entry.ar;
  }

  return null;
}

function translateArabicFacetDataItems(facet) {
  if (!facet || !Array.isArray(facet.data)) return;

  if (isWizzySizeFacetKey(facet.key)) {
    // ensureWizzySizeFacetEnglishLabels(facet);
    return;
  }

  if (isWizzyColorFacetKey(facet.key)) {
    facet.data.forEach(function (item) {
      registerDynamicArabicFilterValue(facet.key, item);

      var labels = extractWizzyFacetItemLabels(item);
      var enValue = labels.en || item.key;
      var arValue = labels.ar || resolveArabicColorLabel(enValue || item.key);
      if (!arValue) return;

      item.label = arValue;
      if (item.name) item.name = arValue;
      if (item.title) item.title = arValue;
    });
    return;
  }

  facet.data.forEach(function (item) {
    registerDynamicArabicFilterValue(facet.key, item);

    var labels = extractWizzyFacetItemLabels(item);
    var enValue = labels.en || item.key;
    var arValue = labels.ar || resolveArabicFilterValue(facet.key, enValue || item.key);
    if (!arValue) return;

    var currentLabel = item.label || item.name || item.title || item.key;
    if (arValue === currentLabel) return;

    if (item.label !== undefined) item.label = arValue;
    if (item.name) item.name = arValue;
    if (item.title) item.title = arValue;
  });
}

function getArabicStaticUiLabel(key, fallback) {
  if (!isWizzyArabicStoreContext()) return fallback;
  return WIZZY_ARABIC_UI_LABELS.static[key] || fallback;
}

function translateArabicSortCollection(sortList) {
  if (!Array.isArray(sortList)) return;

  sortList.forEach(function (sortItem) {
    registerDynamicArabicSort(sortItem);
    var labels = splitWizzyEnArLabels([
      sortItem.label, sortItem.name, sortItem.title,
      sortItem.arLabel, sortItem.labelAr, sortItem.displayLabel
    ], null);
    var arLabel = labels.ar || resolveArabicSortLabel(sortItem);
    if (!arLabel) return;
    if (sortItem.label) sortItem.label = arLabel;
    if (sortItem.name) sortItem.name = arLabel;
    if (sortItem.title) sortItem.title = arLabel;
  });
}

function translateArabicFacetCollection(facets) {
  if (!Array.isArray(facets)) return;

  facets.forEach(function (facet) {
    registerDynamicArabicFilter(facet);

    var arTitle = resolveArabicFilterTitle(facet);
    if (arTitle) {
      if (facet.title) facet.title = arTitle;
      if (facet.label) facet.label = arTitle;
      if (facet.name) facet.name = arTitle;
    }

    translateArabicFacetDataItems(facet);
  });
}

function applyArabicSortConfigLabels() {
  if (!isWizzyArabicStoreContext()) return;

  var sortConfigs = window.wizzyConfig &&
    window.wizzyConfig.search &&
    window.wizzyConfig.search.configs &&
    window.wizzyConfig.search.configs.sorts &&
    window.wizzyConfig.search.configs.sorts.configs;

  translateArabicSortCollection(sortConfigs);
}

function applyArabicLabelsToWizzyApiResponse(data) {
  if (!isWizzyArabicStoreContext() || !data || !data.response) return data;

  if (data.api !== 'search' && data.api !== 'filter') return data;

  var payload = data.response.payload;
  if (!payload) return data;

  if (Array.isArray(payload.facets)) {
    translateArabicFacetCollection(payload.facets);
  }

  if (Array.isArray(payload.sort)) {
    translateArabicSortCollection(payload.sort);
  }
  if (Array.isArray(payload.sorts)) {
    translateArabicSortCollection(payload.sorts);
  }
  if (payload.sort && Array.isArray(payload.sort.options)) {
    translateArabicSortCollection(payload.sort.options);
  }

  return data;
}

function applyArabicStaticWizzyUiLabels() {
  if (!isWizzyArabicStoreContext()) return;

  // var labels = WIZZY_ARABIC_UI_LABELS.static;
  // var filtersOpen = document.body.classList.contains('change-ui-wizzy');

  // document.querySelectorAll('.wizzy-filters-desktop-toggle-btn').forEach(function (btn) {
  //   btn.textContent = filtersOpen ? labels.hideFilters : labels.showFilters;
  // });

  // document.querySelectorAll('.wizzy-mobile-sort-title, .wizzy-mobile-sort-apply').forEach(function (el) {
  //   el.textContent = labels.sort;
  // });

  // document.querySelectorAll('.wizzy-search-sort-wrapper .wizzy-common-select-label').forEach(function (el) {
  //   el.textContent = labels.sortBy;
  // });

  // document.querySelectorAll('.wizzy-search-filters-left .wizzy-filters-header .header-title').forEach(function (el) {
  //   el.textContent = labels.filters;
  // });

  // document.querySelectorAll('.wizzy-filters-mobile-entry').forEach(function (el) {
  //   var countEl = el.querySelector('.wz-active-filters-mobile-count');
  //   var countHtml = countEl ? countEl.outerHTML : '';
  //   el.innerHTML = labels.filter + (countHtml ? ' ' + countHtml : '');
  // });

  // document.querySelectorAll('.wizzy-search-pagination .pagination-arrow.next-arrow .text-mobile').forEach(function (el) {
  //   el.textContent = labels.loadMore;
  // });

  // document.querySelectorAll('.wizzy-common-select-option-label').forEach(function (el) {
  //   var arLabel = resolveArabicSortLabel({ label: (el.textContent || '').trim() });
  //   if (arLabel) el.textContent = arLabel;
  // });

  // document.querySelectorAll('.wizzy-filters-facet-block .facet-head-title').forEach(function (el) {
  //   var arTitle = resolveArabicFilterTitle({ title: (el.textContent || '').trim() });
  //   if (arTitle) el.textContent = arTitle;
  // });

  // document.querySelectorAll('.wizzy-grid-filters-box .facet-head-title').forEach(function (el) {
  //   var arTitle = resolveArabicFilterTitle({ title: (el.textContent || '').trim() });
  //   if (arTitle) el.textContent = arTitle;
  // });

  // document.querySelectorAll('.facet-item-label-value').forEach(function (el) {
  //   var block = el.closest('.wizzy-filters-facet-block, .wizzy-grid-filters-box');
  //   var facetKey = block ? block.getAttribute('data-key') : null;
  //   if (isWizzySizeFacetKey(facetKey)) return;
  //   var enValue = (el.textContent || '').trim();
  //   var arValue = resolveArabicFilterValue(facetKey, enValue);
  //   if (arValue) el.textContent = arValue;
  // });

  // // syncSizeFacetLabelsFromApi();

  // document.querySelectorAll('.wizzy-selected-facet-list-item .wizzy-selected-facet-label').forEach(function (el) {
  //   var enValue = (el.textContent || '').trim();
  //   var arValue = resolveArabicColorLabel(enValue) || resolveArabicFilterValue(null, enValue);
  //   if (arValue) el.textContent = arValue;
  // });

  // updateMobileDrawerFooterLabels(document.body.classList.contains('wizzy-mobile-filter-sub-open'));

  var noResultsContent = document.querySelector('.wizzy-search-empty-results-wrapper .wizzy-empty-results-content p');

  if (noResultsContent) {
    var text = noResultsContent.innerText.trim();

    if (text) {
      noResultsContent.innerText = translateToArabic(text);
    }
  }

  var summary = document.querySelector('.wizzy-empty-results-summary p');

  if (summary && summary.firstChild.nodeType === Node.TEXT_NODE) {
    summary.firstChild.textContent =
    translateToArabic(summary.firstChild.textContent.trim()) + ' ';
  }

  var summary = document.querySelector('.wizzy-summary-head');

  if (summary) {
    var text = summary.textContent;
    var match = text.match(/^(.*?)\s([“"].+[”"])$/);

    if (match) {
      summary.textContent = translateToArabic(match[1]) + ' ' + match[2];
    }
  }
}

function getWizzyProductTags(product) {
  var tags = [];
  var seen = {};

  function addTag(tag) {
    if (!tag || typeof tag !== 'string') return;
    var trimmed = tag.trim();
    if (!trimmed || seen[trimmed]) return;
    seen[trimmed] = true;
    tags.push(trimmed);
  }

  if (Array.isArray(product.tags)) {
    product.tags.forEach(addTag);
  }

  (product.attributes || []).forEach(function (attribute) {
    var id = (attribute.id || '').toLowerCase();
    var isTagAttr = id === 'product_tags' ||
      id === 'shopify_tags' ||
      id.indexOf('product_tag') > -1 ||
      id.indexOf('tags') > -1;

    if (!isTagAttr) return;

    (attribute.values || []).forEach(function (valueObj) {
      var values = valueObj && valueObj.value ? valueObj.value : [];
      if (!Array.isArray(values)) values = [values];
      values.forEach(function (val) {
        if (typeof val !== 'string') return;
        if (val.indexOf(',') > -1) {
          val.split(',').forEach(addTag);
        } else {
          addTag(val);
        }
      });
    });
  });

  return tags;
}

function resolveTagBadgeLabel(tags) {
  var isAr = isArabicLocale();
  var hasBOS = false;
  var hasBestseller = false;
  var hasExclusive = false;
  var hasNew = false;

  (tags || []).forEach(function (tag) {
    if (tag === 'BOS15' || tag === 'BOSA15') hasBOS = true;
    if (tag === 'bestseller') hasBestseller = true;
    if (tag === 'DEL AUG') hasExclusive = true;
    if (tag === 'NEW26_FEB') hasNew = true;
  });

  if (hasBOS) return isAr ? 'استخدم الرمز: BOS' : 'Use code: BOS';
  if (hasBestseller) return isAr ? 'الأكثر مبيعًا' : 'Bestseller';
  if (hasExclusive) return isAr ? 'حصري' : 'Exclusive';
  if (hasNew) return isAr ? 'وصول جديد' : 'New Arrival';
  return null;
}

function normalizeValueTagLabel(label) {
  if (!label || typeof label !== 'string') return null;
  var normalized = {
    'New Arrivals': 'New Arrival',
    'NEW ARRIVAL': 'New Arrival',
    'Best Seller': 'Bestseller',
    'BEST SELLER': 'Bestseller'
  };
  return normalized[label] || label;
}

function ensureWizzyGridFilterPlacement() {
  var searchWrapper = document.querySelector('.wizzy-search-wrapper');
  if (!searchWrapper) return;

  var target = searchWrapper.querySelector('.filters-list-top-values-wrapper');
  if (!target) return;

  var gridBoxes = searchWrapper.querySelectorAll('.wizzy-grid-filters-box');
  gridBoxes.forEach(function (box) {
    if (box.parentElement !== target) {
      target.appendChild(box);
    }
  });
}

function isWizzyMobileGridView() {
  return window.innerWidth <= 989;
}
function scheduleMobileGridFilterUI() {
  if (!isWizzyMobileGridView()) return;

  function applyMobileGridFilterState() {
    document.querySelectorAll('.wizzy-grid-filters-box').forEach(function (box) {
      var filterOptions = box.querySelector('.wizzy-facet-body');
      if (filterOptions) filterOptions.classList.remove('collapsed', 'expanded');

      var toggleBtn = box.querySelector('.wizzy-toggle-btn, .wzGridFilters-more-less-btn');
      if (toggleBtn) {
        toggleBtn.classList.remove('is-visible');
        toggleBtn.style.display = 'none';
      }

      var mobileLabel = box.querySelector('.wizzy-more-toggle-label');
      if (mobileLabel) mobileLabel.style.display = 'none';

      box.classList.remove('wizzy-grid-filter-has-more', 'wizzy-grid-filter-expanded');
    });
  }

  applyMobileGridFilterState();
  if (typeof requestAnimationFrame === 'function') {
    requestAnimationFrame(applyMobileGridFilterState);
  }
}

function bindGridFilterResizeHandler() {
  if (window._wizzyGridFilterResize) return;
  window._wizzyGridFilterResize = true;
  window.addEventListener('resize', function () {
    // prepareWizzyGridFilterUI();
    scheduleMobileGridFilterUI();
  });
}

function getWizzyCollectionTitle() {
  if (window.wizzyConfig && window.wizzyConfig.common && window.wizzyConfig.common.categoryName) {
    return window.wizzyConfig.common.categoryName;
  }
  if (typeof getShopifyCollectionTitle === 'function') {
    return getShopifyCollectionTitle();
  }
  return null;
}

function getWizzyTotalCount(payload) {
  var response = payload && payload.data && payload.data.response;
  var responsePayload = response && response.payload;

  if (responsePayload && typeof responsePayload.total === 'number') {
    return responsePayload.total;
  }

  if (responsePayload && responsePayload.pagination && typeof responsePayload.pagination.total === 'number') {
    return responsePayload.pagination.total;
  }

  return null;
}

function getWizzyViewedProductCount() {
  return document.querySelectorAll('.wizzy-search-wrapper .wizzy-result-product').length;
}

function getWizzyPaginationTotal(payload) {
  var store = window.wizzyConfig && window.wizzyConfig.pageStore;
  var searched = store && store.searchedResponse;

  if (searched && typeof searched.total === 'number') {
    return searched.total;
  }

  return getWizzyTotalCount(payload);
}

function formatWizzyCount(n) {
  try {
    return Number(n).toLocaleString('en-US');
  } catch (e) {
    return String(n);
  }
}

function syncWizzyPaginationProgress(payload) {
  var countEl = document.querySelector('.wizzy-search-pagination #product-count-message');
  var barEl = document.querySelector('.wizzy-search-pagination #product-progress-bar');
  if (!countEl || !barEl) return;

  var total = getWizzyPaginationTotal(payload);
  var viewed = getWizzyViewedProductCount();

  document.querySelectorAll(
    '.wizzy-search-pagination .pagination-arrow.next-arrow .text-mobile'
  ).forEach(function (el) {
    el.textContent = isArabicLocale() ? translateToArabic('Load more') : 'Load more';
  });

  if (!total || total <= 0) {
    countEl.textContent = '';
    barEl.style.width = '0%';
    return;
  }

  var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
  var isAr = lang.indexOf('ar') === 0;
  var viewedLabel = formatWizzyCount(viewed);
  var totalLabel = formatWizzyCount(total);

  var viewedText = isArabicLocale() ? translateToArabic("You've viewed") : "You've viewed";
  var ofText = isArabicLocale() ? translateToArabic("of") : "of";
  var productsText = isArabicLocale() ? translateToArabic("products") : "products";

  countEl.textContent = isAr
    ? viewedText + ' ' + viewedLabel + ' ' + ofText + ' ' + totalLabel + ' ' + productsText
    : "You've viewed " + viewedLabel + ' of ' + totalLabel + ' products';

  var percent = Math.min((viewed / total) * 100, 100);
  barEl.style.width = percent + '%';
}

function syncWizzyCollectionHero(payload) {
  var wrapper = document.querySelector('.wizzy-category-page');
  if (!wrapper) return;

  var titleEl = wrapper.querySelector('.collection-hero__title');
  var countEl = wrapper.querySelector('#ProductCountDesktop');
  var title = getWizzyCollectionTitle();

  if (titleEl && title) {
    var hiddenLabel = titleEl.querySelector('.visually-hidden');
    titleEl.textContent = '';
    if (hiddenLabel) {
      titleEl.appendChild(hiddenLabel);
    } else {
      var label = document.createElement('span');
      label.className = 'visually-hidden';
      label.textContent = 'Collection: ';
      titleEl.appendChild(label);
    }
    titleEl.appendChild(document.createTextNode(title));
  }

  if (countEl && payload) {
    var total = getWizzyTotalCount(payload);
    if (typeof total === 'number') {
      countEl.textContent = total + (total === 1 ? ' item' : ' items');
    }
  }
}

function buildCategorySidebar() {
  if (!(window.wizzyConfig && window.wizzyConfig.common && window.wizzyConfig.common.isOnCategoryPage)) {
    return;
  }

  var rawData = window.groupedCategories;
  if (!rawData) return;

  rawData = rawData.replace(/&gt;/g, '>').replace(/&amp;/g, '&');

  var categoryGroups = rawData.split('||');
  var hasParentStructure = categoryGroups.some(function (group) {
    return group.indexOf('++') > -1 && group.indexOf('>') > -1;
  });

  var sidebar = document.createElement('div');
  sidebar.className = 'sidebar-categories';

  var ul = document.createElement('ul');
  ul.className = 'category-list';
  ul.setAttribute('role', 'list');

  if (hasParentStructure) {
    categoryGroups.forEach(function (group) {
      var parentParts = group.split('++');
      var parentHandleRaw = parentParts[0];
      var remainderRaw = parentParts[1] || '';
      var remainderParts = remainderRaw.split('>');
      var parentTitleRaw = remainderParts[0];
      var childrenRaw = remainderParts[1];

      var parentHandle = parentHandleRaw.trim();
      var parentTitle = parentTitleRaw.trim();
      var childrenList = childrenRaw ? childrenRaw.split(',') : [];

      var li = document.createElement('li');
      var details = document.createElement('details');
      var summary = document.createElement('summary');
      summary.className = 'category-item';

      var a = document.createElement('a');
      a.className = 'category-titles';
      a.href = '/collections/' + parentHandle;
      a.textContent = parentTitle;
      summary.appendChild(a);

      summary.innerHTML += '<span class="icon icon-plus"><svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-plus" viewBox="0 0 10 10"><path fill="currentColor" fill-rule="evenodd" d="M1 4.51a.5.5 0 0 0 0 1h3.5l.01 3.5a.5.5 0 0 0 1-.01V5.5l3.5-.01a.5.5 0 0 0-.01-1H5.5L5.49.99a.5.5 0 0 0-1 .01v3.5l-3.5.01z" clip-rule="evenodd"></path></svg></span><span class="icon icon-minus"><svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-minus" viewBox="0 0 10 2"><path fill="currentColor" fill-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 1 1 0 1H1A.5.5 0 0 1 .5 1" clip-rule="evenodd"></path></svg></span>';

      var subUl = document.createElement('ul');
      subUl.className = 'sub-category-list accordion__content rte';

      childrenList.forEach(function (child) {
        var childParts = child.split('--');
        var childHandle = childParts[0].trim();
        var childTitle = (childParts[1] || '').trim();

        var subLi = document.createElement('li');
        var subA = document.createElement('a');
        subA.href = '/collections/' + childHandle;
        subA.textContent = childTitle;
        subLi.appendChild(subA);
        subUl.appendChild(subLi);
      });

      details.appendChild(summary);
      details.appendChild(subUl);
      li.appendChild(details);
      ul.appendChild(li);
    });
  } else {
    var flatChildren = rawData.split(',');
    flatChildren.forEach(function (child) {
      var childParts = child.split('--');
      var childHandle = childParts[0].trim();
      var childTitle = (childParts[1] || '').trim();

      var flatLi = document.createElement('li');
      var flatA = document.createElement('a');
      flatA.href = '/collections/' + childHandle;
      flatA.textContent = childTitle;
      flatLi.appendChild(flatA);
      ul.appendChild(flatLi);
    });
  }

  sidebar.appendChild(ul);

  var target = document.querySelector('.wizzy-facet-body.facet-body-product_value_tags_category_tags');
  if (target) {
    target.innerHTML = '';
    target.appendChild(sidebar);
  }
}

function updateCollectionTitleAndCount() {
  if (window.collectionName) {
    var collectionTitle = document.querySelector('h1.collection-hero__title');
    if (collectionTitle) {
      collectionTitle.innerHTML = '<span class="visually-hidden">Collection: </span>' + window.collectionName;
    }
  }

  var productsCount = window.wizzyConfig && window.wizzyConfig.pageStore && window.wizzyConfig.pageStore.searchedResponse && window.wizzyConfig.pageStore.searchedResponse.total;
  if (productsCount) {
    var productCountElement = document.querySelector('#ProductCountDesktop');
    if (productCountElement) {
      productCountElement.innerHTML = '<span id="ProductCountDesktop">' + productsCount + ' items<span>';
    }
  }
}

/* =============================================================================
   WISHLIST — Wizzy bridge (starts here)
   -----------------------------------------------------------------------------
   PLP/native wishlist is owned by assets/global.js:
     • click toggle on .wishlist-icon
     • wishlist cookie read/write
     • updateWishlistUI() for body wish-* classes and header count
   Do not duplicate or intercept that logic here.
   Wizzy only re-applies .active on its own cards after each DOM re-render.
   Selector .wizzy-result-product scopes this to Wizzy cards — PLP is untouched.
   ============================================================================= */
function syncWizzyWishlistAfterRender() {
  if (typeof getCookie !== 'function') return;

  var wishlist = getCookie('wishlist');
  var handles = wishlist ? wishlist.split(',').filter(Boolean) : [];

  document.querySelectorAll('.wizzy-result-product .wishlist-icon').forEach(function (icon) {
    if (icon.classList.contains('sfl_action')) return;
    var handle = icon.getAttribute('data-handle');
    icon.classList.toggle('active', !!(handle && handles.indexOf(handle) > -1));
  });

  if (typeof updateWishlistUI === 'function') {
    updateWishlistUI();
  }
}
/* WISHLIST — Wizzy bridge (ends here) */

function loadStampedBadges() {
  function run() {
    if (typeof StampedFn === 'undefined') return;

    if (typeof StampedFn.loadBadges === 'function') {
      StampedFn.loadBadges();
    }

    if (typeof jQuery !== 'undefined') {
      jQuery('.wizzy-search-wrapper .stamped-product-reviews-badge').each(function () {
        if (typeof StampedFn.loadBadge === 'function') {
          StampedFn.loadBadge(this);
        }
      });
    }
  }

  run();
  setTimeout(run, 400);
  setTimeout(run, 1200);
  setTimeout(run, 2500);
}

var WIZZY_CHECKMARK_SVG =
  '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-checkmark" viewBox="0 0 12 9">' +
  '<path fill="currentColor" fill-rule="evenodd" d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z" clip-rule="evenodd"></path>' +
  '</svg>';

var WIZZY_FACET_SQUARE_SVG =
  '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">' +
  '<rect x="0.5" y="0.5" width="17" height="17" stroke="black"></rect>' +
  '</svg>';

function customizeWizzyFilterCheckboxes() {
  document.querySelectorAll('.wizzy-search-wrapper .checkbox-indicator').forEach(function (indicator) {
    if (indicator.closest('.wizzy-grid-filters-box')) return;
    if (indicator.dataset.wizzyCheckmarkDone) return;

    var parent = indicator.parentElement;
    var input = parent && parent.querySelector('input[type="checkbox"]');
    if (!input) return;

    indicator.dataset.wizzyCheckmarkDone = '1';
    indicator.style.display = 'none';

    var square = document.createElement('span');
    square.className = 'wizzy-facet-square';
    square.innerHTML = WIZZY_FACET_SQUARE_SVG;

    var wrap = document.createElement('div');
    wrap.className = 'svg-wrapper wizzy-facet-checkmark';
    wrap.innerHTML = WIZZY_CHECKMARK_SVG;

    input.insertAdjacentElement('afterend', square);
    square.insertAdjacentElement('afterend', wrap);

    parent.classList.add('wizzy-facet-checkbox');
  });
}

function formatWizzyFacetCounts() {
  document.querySelectorAll('.wizzy-search-wrapper .wizzy-facet-list-item-count').forEach(function (el) {
    var text = (el.textContent || '').trim();
    var match = text.match(/\(?\s*(\d[\d,]*)\s*\)?/);

    if (match && text !== match[1]) {
      el.textContent = match[1];
    }
  });
}

var WIZZY_ARABIC_CURRENCY_PATTERN = /aed/i;

function formatWizzyPriceNoDecimals(value) {
  if (value === null || value === undefined || value === '') return value;

  if (typeof value === 'number') {
    return isNaN(value) ? value : Math.round(value);
  }

  var str = String(value);
  if (/\d+\.\d+/.test(str)) {
    return str.replace(/(\d+\.\d+)/g, function (match) {
      var num = parseFloat(match);
      return isNaN(num) ? match : String(Math.round(num));
    });
  }

  var num = parseFloat(str.replace(/[^\d.-]/g, ''));
  if (isNaN(num)) return value;

  return String(Math.round(num));
}

var WIZZY_PRODUCT_PRICE_FIELDS = [
  'sellingPrice',
  'price',
  'retailPrice',
  'newSellingPrice',
  'finalPrice',
  'compareAtPrice',
  'originalPrice',
  'discount',
  'formattedSellingPrice',
  'formattedPrice',
  'sellingPriceFormatted',
  'priceFormatted',
  'displayPrice',
  'regularPrice',
  'salePrice',
  'mrp'
];

function normalizeWizzyProductPriceFields(product) {
  if (!product) return;

  WIZZY_PRODUCT_PRICE_FIELDS.forEach(function (field) {
    if (product[field] !== undefined && product[field] !== null && product[field] !== '') {
      product[field] = formatWizzyPriceNoDecimals(product[field]);
    }
  });
}

function normalizeWizzyProductsPriceList(products) {
  if (!Array.isArray(products)) return;
  products.forEach(normalizeWizzyProductPriceFields);
}

function getAutocompleteProductsFromApiResponse(data) {
  var products = data && data.response && data.response.payload && data.response.payload.products;
  if (!products) return [];

  if (Array.isArray(products.result)) return products.result;
  if (Array.isArray(products)) return products;
  if (Array.isArray(products.items)) return products.items;

  return [];
}

function stripRenderedPriceDecimals(root) {
  if (window._wizzyPriceStripRunning) return;

  var scope = root && root.querySelectorAll ? root : document;
  var selectors = [
    '.product-item-selling-price',
    '.product-item-retail-price',
    '.wizzy-autocomplete-products .product-item-selling-price',
    '.wizzy-autocomplete-products .product-item-retail-price',
    '.wizzy-product-item-price .price-item',
    '.wizzy-product-item-price .price-item--regular',
    '.wizzy-product-item-price .price-item--sale',
    '.wizzy-result-product .price-item',
    '.wizzy-result-product .price-item--regular',
    '.wizzy-result-product .price-item--sale'
  ];

  window._wizzyPriceStripRunning = true;
  try {
    selectors.forEach(function (selector) {
      scope.querySelectorAll(selector).forEach(function (el) {
        var text = (el.textContent || '').trim();
        if (!/\d+\.\d+/.test(text)) return;

        el.textContent = text.replace(/(\d+\.\d+)/g, function (match) {
          var num = parseFloat(match);
          return isNaN(num) ? match : String(Math.round(num));
        });
      });
    });
  } finally {
    window._wizzyPriceStripRunning = false;
  }
}

function scheduleStripRenderedPriceDecimals(root, immediate) {
  var run = function () {
    stripRenderedPriceDecimals(root);
    // enhanceAutocompleteUI(root);
  };

  if (immediate) {
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(run);
    } else {
      run();
    }
    return;
  }

  if (typeof requestAnimationFrame === 'function') {
    requestAnimationFrame(run);
  } else {
    run();
  }

  window.setTimeout(run, 60);
}

function getWizzyAutocompleteWrapper() {
  return document.querySelector('.wizzy-autocomplete-wrapper, [data-wizzy-autocomplete-wrapper]');
}

var WIZZY_AC_SEARCH_SVG =
  '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">' +
  '<path d="M13.825 13.0083L10.6867 9.87C11.55 8.82 12.0867 7.50167 12.0867 6.04333C12.0983 2.71833 9.38 0 6.04333 0C2.70667 0 0 2.71833 0 6.04333C0 9.36833 2.71833 12.0867 6.04333 12.0867C7.50167 12.0867 8.82 11.55 9.87 10.6867L13.0083 13.825C13.125 13.9417 13.2767 14 13.4167 14C13.5567 14 13.72 13.9417 13.825 13.825C14.0583 13.6033 14.0583 13.23 13.825 13.0083ZM1.16667 6.04333C1.16667 3.36 3.36 1.16667 6.04333 1.16667C8.72667 1.16667 10.92 3.36 10.92 6.04333C10.92 8.72667 8.72667 10.92 6.04333 10.92C3.36 10.92 1.16667 8.73833 1.16667 6.04333Z" fill="black"></path></svg>';

function injectAcSearchIcon(target) {
  if (!target || target.querySelector('.wizzy-ac-search-icon')) return;

  var icon = document.createElement('span');
  icon.className = 'wizzy-ac-search-icon';
  icon.setAttribute('aria-hidden', 'true');
  icon.innerHTML = WIZZY_AC_SEARCH_SVG;
  target.insertBefore(icon, target.firstChild);
}

function enhanceAutocompleteUI(root) {
  root = root || getWizzyAutocompleteWrapper();
  if (!root) return;

  var skipPillSections =
    '.wizzy-autocomplete-popular-searches, .wizzy-autocomplete-trending-searches, .wizzy-autocomplete-trending-keywords';

  root
    .querySelectorAll(
      '.wizzy-autocomplete-suggestions li.autocomplete-item, .wizzy-autocomplete-suggestions .wizzy-autocomplete-suggestion-item, .wizzy-autocomplete-suggestions .wizzy-autocomplete-suggestion'
    )
    .forEach(function (item) {
      if (item.closest(skipPillSections)) return;
      injectAcSearchIcon(item.querySelector('a') || item);
    });

  root.querySelectorAll('.wizzy-autocomplete-suggestions a, .wizzy-autocomplete-suggestion-item a').forEach(function (link) {
    if (link.closest(skipPillSections)) return;
    if (link.closest('li.autocomplete-item, .wizzy-autocomplete-suggestion-item, .wizzy-autocomplete-suggestion')) return;
    injectAcSearchIcon(link);
  });

  var staticFallback = document.querySelector('.getdata-serch-result .search-no-results.suggestion-no-result');
  if (staticFallback) {
    staticFallback.style.display = root.children.length ? 'none' : '';
  }
}

function afterAutocompleteRender() {
  var wrapper = getWizzyAutocompleteWrapper();
  if (wrapper) {
    stripRenderedPriceDecimals(wrapper);
    // enhanceAutocompleteUI(wrapper);
  }
}

function bindAutocompletePriceDecimalStrip() {
  if (window._wizzyAutocompletePriceStripBound) return;
  window._wizzyAutocompletePriceStripBound = true;

  if (typeof MutationObserver !== 'function') return;

  var observer = new MutationObserver(function (mutations) {
    if (window._wizzyPriceStripRunning) return;

    var root = null;
    for (var i = 0; i < mutations.length; i++) {
      var mutationTarget = mutations[i].target;
      if (!mutationTarget || !mutationTarget.closest) continue;

      var wrapper = mutationTarget.closest('.wizzy-autocomplete-wrapper, [data-wizzy-autocomplete-wrapper]');
      if (wrapper) {
        root = wrapper;
        break;
      }
    }

    if (!root) return;

    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(function () {
        stripRenderedPriceDecimals(root);
        // enhanceAutocompleteUI(root);
      });
    } else {
      stripRenderedPriceDecimals(root);
      // enhanceAutocompleteUI(root);
    }
  });

  var attachObserver = function () {
    document.querySelectorAll('.wizzy-autocomplete-wrapper, [data-wizzy-autocomplete-wrapper]').forEach(function (target) {
      if (target && !target.dataset.wizzyPriceStripObserved) {
        target.dataset.wizzyPriceStripObserved = '1';
        observer.observe(target, { childList: true, subtree: true });
      }
    });
  };

  attachObserver();
  document.addEventListener('DOMContentLoaded', function () {
    attachObserver();
    // enhanceAutocompleteUI();
  });
}

function normalizeAutocompleteProductPrices(product) {
  normalizeWizzyProductPriceFields(product);
}

function normalizeWizzyPriceFilterCurrency() {
  document.querySelectorAll('.wizzy-search-wrapper .wizzy-range-input-wrapper').forEach(function (wrapper) {
    wrapper.classList.add('wizzy-price-aed');

    wrapper.querySelectorAll('label, span, div').forEach(function (el) {
      if (el.classList.contains('wizzy-range-input') || el.classList.contains('checkbox-indicator')) {
        return;
      }

      var text = (el.textContent || '').trim();
      if (text && WIZZY_ARABIC_CURRENCY_PATTERN.test(text)) {
        el.style.display = 'none';
        el.setAttribute('aria-hidden', 'true');
      }
    });
  });

  document.querySelectorAll('.wizzy-search-wrapper .wizzy-facet-range-inputs').forEach(function (inputs) {
    inputs.querySelectorAll(':scope > label, :scope > span').forEach(function (el) {
      var text = (el.textContent || '').trim();
      if (text && WIZZY_ARABIC_CURRENCY_PATTERN.test(text)) {
        el.style.display = 'none';
        el.setAttribute('aria-hidden', 'true');
      }
    });
  });
}

var WIZZY_MOBILE_DRAWER_MAX = 668;
var WIZZY_MOBILE_FACET_SLIDE_MS = 300;

function isMobileFilterDrawer() {
  return window.innerWidth <= WIZZY_MOBILE_DRAWER_MAX;
}

function getMobileFilterPanel() {
  return document.querySelector('.wizzy-search-wrapper .wizzy-search-filters-left.wizzy-v1') ||
    document.querySelector('.wizzy-search-wrapper .wizzy-search-filters-left');
}

function getMobileFilterFacetBlocks(panel) {
  if (!panel) return [];
  var blocks = panel.querySelectorAll('.wizzy-facet-list-block .wizzy-filters-facet-block:not(.wizzy-grid-filters-box)');
  if (!blocks.length) {
    blocks = panel.querySelectorAll('.wizzy-filters-facet-block:not(.wizzy-grid-filters-box), [class*="facet-block-"]:not(.wizzy-grid-filters-box)');
  }
  return Array.prototype.slice.call(blocks);
}

function getMobileFacetBlockFromHead(facetHead) {
  if (!facetHead) return null;
  var facetBlock = facetHead.closest('.wizzy-filters-facet-block, [class*="facet-block-"]');
  if (!facetBlock || facetBlock.classList.contains('wizzy-grid-filters-box')) return null;
  return facetBlock;
}

function getMobileFacetBlockKey(block) {
  if (!block) return '';
  var match = (block.className || '').match(/\bfacet-block-[\w-]+/);
  return match ? match[0] : '';
}

function resolveMobileActiveFacetBlock(panel) {
  if (!panel) return null;
  var blocks = getMobileFilterFacetBlocks(panel);
  var key = window._wizzyMobileActiveFacetKey;
  var index = window._wizzyMobileActiveFacetIndex;

  if (key) {
    for (var i = 0; i < blocks.length; i++) {
      if (blocks[i].classList.contains(key)) return blocks[i];
    }
  }

  if (index != null && blocks[index]) return blocks[index];

  var cached = window._wizzyMobileActiveFacetBlock;
  if (cached && document.contains(cached)) return cached;

  return null;
}

function getMobileFacetStage(panel) {
  if (!panel) return null;
  var wrapper = panel.querySelector('.wizzy-search-filters-left-wrapper');
  if (!wrapper) return null;

  var stage = wrapper.querySelector('.wizzy-mobile-facet-stage');
  if (!stage) {
    stage = document.createElement('div');
    stage.className = 'wizzy-mobile-facet-stage';
    wrapper.insertBefore(stage, wrapper.firstChild);
  }
  return stage;
}

function restoreMobileFacetBodyPlacement() {
  var placement = window._wizzyMobileFacetBodyPlacement;
  if (!placement || !placement.body || !placement.parent) {
    window._wizzyMobileFacetBodyPlacement = null;
    return;
  }

  if (!document.contains(placement.parent)) {
    window._wizzyMobileFacetBodyPlacement = null;
    return;
  }

  // if (placement.nextSibling && placement.nextSibling.parentNode === placement.parent) {
  //   placement.parent.insertBefore(placement.body, placement.nextSibling);
  // } else {
  //   placement.parent.appendChild(placement.body);
  // }

  window._wizzyMobileFacetBodyPlacement = null;

  var panel = getMobileFilterPanel();
  if (panel) {
    var stage = panel.querySelector('.wizzy-mobile-facet-stage');
    if (stage) stage.classList.remove('wizzy-mobile-facet-stage-active');
  }
}

function mountMobileFacetBodyToStage(panel, block, facetBody) {
  if (!panel || !block || !facetBody) return;

  restoreMobileFacetBodyPlacement();

  var stage = getMobileFacetStage(panel);
  if (!stage) return;

  window._wizzyMobileFacetBodyPlacement = {
    body: facetBody,
    parent: block,
    nextSibling: facetBody.nextSibling
  };

  // stage.appendChild(facetBody);
  stage.innerHTML = '';

  var facetBodyClone = facetBody.cloneNode(true);

  stage.appendChild(facetBodyClone);

  window._wizzyMobileFacetBodyClone = facetBodyClone;
  stage.classList.add('wizzy-mobile-facet-stage-active');

  bindStageFacetItems();

  return facetBodyClone;
}

function clearMobileFacetBodyInlineStyles(facetBody) {
  if (!facetBody) return;
  facetBody.classList.remove('wizzy-mobile-facet-body-open', 'wizzy-mobile-facet-body-closing');
  facetBody.style.display = '';
  facetBody.style.visibility = '';
  facetBody.style.transform = '';
  facetBody.style.pointerEvents = '';
}

function showMobileFacetBody(facetBody) {
  if (!facetBody) return;
  facetBody.classList.remove('wizzy-mobile-facet-body-closing');
  facetBody.classList.remove('wizzy-mobile-facet-body-open');
  facetBody.style.display = 'block';
  facetBody.style.visibility = 'visible';
  facetBody.style.pointerEvents = 'none';
  facetBody.style.transform = '';

  if (typeof requestAnimationFrame === 'function') {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        facetBody.classList.add('wizzy-mobile-facet-body-open');
        facetBody.style.pointerEvents = '';
      });
    });
  } else {
    facetBody.classList.add('wizzy-mobile-facet-body-open');
    facetBody.style.pointerEvents = '';
  }
}

function tryOpenMobileFilterCategoryFromTarget(target) {
  if (!target || !target.closest) return false;
  if (!isMobileFilterDrawer()) return false;
  if (!document.querySelector('.wizzy-search-wrapper .wizzy-search-filters-left.wizzy-mobile-drawer-enhanced')) return false;
  if (!target.closest('.wizzy-search-filters-left.wizzy-mobile-drawer-enhanced')) return false;
  if (target.closest('.wizzy-mobile-subfilter-back, .wizzy-mobile-main-back, .wizzy-filters-close-btn, .wizzy-mobile-subfilter-close, .wizzy-filters-bg, .wizzy-filters-close-button, .wizzy-apply-all-button')) {
    return false;
  }
  if (document.body.classList.contains('wizzy-mobile-filter-sub-open')) return false;

  var facetBlock = null;
  var facetHead = target.closest('.wizzy-facet-head');
  if (facetHead) {
    facetBlock = getMobileFacetBlockFromHead(facetHead);
  }
  if (!facetBlock) {
    facetBlock = target.closest('.wizzy-filters-facet-block:not(.wizzy-grid-filters-box)');
  }
  if (!facetBlock) return false;

  setTimeout(function () {
    openMobileFilterCategory(facetBlock);
  }, 200);
  return true;
}

function snapshotMobileFilterState() {
  var panel = getMobileFilterPanel();
  if (!panel) return null;

  var snapshot = [];
  getMobileFilterFacetBlocks(panel).forEach(function (block, index) {
    var facetState = { index: index, checkboxes: [], ranges: [] };

    block.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach(function (input) {
      facetState.checkboxes.push({
        name: input.name || '',
        value: input.value || '',
        checked: !!input.checked
      });
    });

    block.querySelectorAll('input.wizzy-range-input, input[type="number"]').forEach(function (input) {
      facetState.ranges.push({
        name: input.name || '',
        value: input.value || ''
      });
    });

    snapshot.push(facetState);
  });

  return snapshot;
}

function restoreMobileFilterSnapshot(snapshot) {
  var panel = getMobileFilterPanel();
  if (!panel || !snapshot) return;

  var blocks = getMobileFilterFacetBlocks(panel);
  snapshot.forEach(function (facetState) {
    var block = blocks[facetState.index];
    if (!block) return;

    facetState.checkboxes.forEach(function (saved) {
      block.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach(function (input) {
        if ((input.name || '') === saved.name && (input.value || '') === saved.value) {
          input.checked = !!saved.checked;
        }
      });
    });

    facetState.ranges.forEach(function (saved) {
      block.querySelectorAll('input.wizzy-range-input, input[type="number"]').forEach(function (input) {
        if ((input.name || '') === saved.name) {
          input.value = saved.value;
        }
      });
    });
  });

  syncMobileFilterSummaries();
}

function injectMobileDrawerUI(panel) {
  if (!panel) return;

  var header = panel.querySelector('.wizzy-filters-header');
  if (header && !header.querySelector('.wizzy-mobile-main-back')) {
    var mainBack = document.createElement('button');
    mainBack.type = 'button';
    mainBack.className = 'wizzy-mobile-main-back';
    mainBack.setAttribute('aria-label', 'Close filters');
    header.insertBefore(mainBack, header.firstChild);
  }

  if (!panel.querySelector('.wizzy-mobile-subfilter-header')) {
    var subHeader = document.createElement('div');
    subHeader.className = 'wizzy-mobile-subfilter-header';
    subHeader.innerHTML =
      '<button type="button" class="wizzy-mobile-subfilter-back" aria-label="Back to filters"></button>' +
      '<p class="wizzy-mobile-subfilter-title"></p>' +
      '<button type="button" class="wizzy-mobile-subfilter-close" aria-label="Close filters"></button>';

    if (header && header.parentNode) {
      header.parentNode.insertBefore(subHeader, header.nextSibling);
    }
  }

  getMobileFacetStage(panel);

  getMobileFilterFacetBlocks(panel).forEach(function (block) {
    var head = block.querySelector('.wizzy-facet-head');
    if (!head) return;

    if (!head.querySelector('.wizzy-mobile-facet-summary')) {
      var summary = document.createElement('span');
      summary.className = 'wizzy-mobile-facet-summary';
      head.appendChild(summary);
    }

    if (!head.querySelector('.wizzy-mobile-facet-chevron')) {
      var chevron = document.createElement('span');
      chevron.className = 'wizzy-mobile-facet-chevron';
      chevron.setAttribute('aria-hidden', 'true');
      head.appendChild(chevron);
    }
  });

  updateMobileDrawerFooterLabels(document.body.classList.contains('wizzy-mobile-filter-sub-open'));
}

function updateMobileDrawerFooterLabels(isSubOpen) {
  if (!isMobileFilterDrawer()) return;

  var panel = getMobileFilterPanel();
  if (!panel) return;

  var applyBtn = panel.querySelector('.wizzy-apply-all-button');
  var clearBtn = panel.querySelector('.wizzy-filters-close-button');
  if (applyBtn) {
    applyBtn.textContent = isSubOpen
      ? getArabicStaticUiLabel('applyFilters', 'Apply Filters')
      : getArabicStaticUiLabel('showResults', 'Show results');
  }
  if (clearBtn) clearBtn.textContent = getArabicStaticUiLabel('clear', 'Clear');
}

function getMobileFacetSummaryText(block) {
  if (!block) return '';

  var isPriceFacet = block.classList.contains('facet-block-price') ||
    block.classList.contains('facet-block-sellingPrice') ||
    /price/i.test(block.className);

  if (isPriceFacet) {
    var minInput = block.querySelector('input.wizzy-range-input[name*="min"], input[name*="min"]');
    var maxInput = block.querySelector('input.wizzy-range-input[name*="max"], input[name*="max"]');
    var minVal = minInput ? (minInput.value || '').trim() : '';
    var maxVal = maxInput ? (maxInput.value || '').trim() : '';
    if (minVal || maxVal) {
      if (minVal && maxVal) return 'AED ' + minVal + '–' + maxVal;
      if (minVal) return 'AED ' + minVal + '+';
      return 'Up to AED ' + maxVal;
    }
  }

  var activeLabels = [];
  block.querySelectorAll('.wizzy-facet-list-item.active, input[type="checkbox"]:checked, input[type="radio"]:checked').forEach(function (el) {
    var item = el.closest('.wizzy-facet-list-item');
    if (!item) return;
    var labelEl = item.querySelector('.facet-item-label-value, .wizzy-facet-list-item-label');
    var labelText = labelEl ? (labelEl.textContent || '').trim() : '';
    if (labelText && activeLabels.indexOf(labelText) === -1) {
      activeLabels.push(labelText);
    }
  });

  if (!activeLabels.length) return '';
  if (activeLabels.length === 1) return activeLabels[0];
  if (activeLabels.length === 2) return activeLabels.join(', ');
  return activeLabels.length + ' selected';
}

function syncMobileFilterSummaries() {
  if (!isMobileFilterDrawer()) return;

  var panel = getMobileFilterPanel();
  if (!panel || !panel.classList.contains('wizzy-mobile-drawer-enhanced')) return;

  getMobileFilterFacetBlocks(panel).forEach(function (block) {
    var summary = block.querySelector('.wizzy-facet-head .wizzy-mobile-facet-summary');
    // if (summary) summary.textContent = getMobileFacetSummaryText(block);
  });
}

function resetMobileFilterNavigation() {
  document.body.classList.remove('wizzy-mobile-filter-sub-open');
  window._wizzyMobileSubOpenActive = false;

  var panel = getMobileFilterPanel();
  if (panel) {
    var stageBody = panel.querySelector('.wizzy-mobile-facet-stage .wizzy-facet-body');
    if (stageBody) {
      stageBody.classList.remove('wizzy-mobile-facet-body-open', 'wizzy-mobile-facet-body-closing');
    }
  } else {
    restoreMobileFacetBodyPlacement();
    window._wizzyMobileActiveFacetBlock = null;
    window._wizzyMobileActiveFacetIndex = null;
    window._wizzyMobileActiveFacetKey = '';
    updateMobileDrawerFooterLabels(false);
    return;
  }

  restoreMobileFacetBodyPlacement();

  getMobileFilterFacetBlocks(panel).forEach(function (block) {
    block.classList.remove('wizzy-mobile-facet-open');
    clearMobileFacetBodyInlineStyles(block.querySelector('.wizzy-facet-body'));
  });

  window._wizzyMobileActiveFacetBlock = null;
  window._wizzyMobileActiveFacetIndex = null;
  window._wizzyMobileActiveFacetKey = '';
  updateMobileDrawerFooterLabels(false);
}

function applyMobileFilterSubOpenState(block) {
  if (!block || !isMobileFilterDrawer()) return;

  var panel = getMobileFilterPanel();
  if (!panel) return;

  block.classList.add('wizzy-mobile-facet-open');
  document.body.classList.add('wizzy-mobile-filter-sub-open');
  window._wizzyMobileActiveFacetBlock = block;
  window._wizzyMobileSubOpenActive = true;

  var facetBody = block.querySelector('.wizzy-facet-body');
  var facetBodyClone = mountMobileFacetBodyToStage(panel, block, facetBody);
  showMobileFacetBody(facetBodyClone);

  var titleEl = panel.querySelector('.wizzy-mobile-subfilter-title');
  var titleSource = block.querySelector('.wizzy-facet-head .facet-head-title');
  if (titleEl && titleSource) {
    titleEl.textContent = (titleSource.textContent || '').trim();
  }

  updateMobileDrawerFooterLabels(true);
}

function openMobileFilterCategory(block) {
  if (!block || !isMobileFilterDrawer()) return;

  var panel = getMobileFilterPanel();
  if (!panel) return;

  var blocks = getMobileFilterFacetBlocks(panel);
  var facetIndex = blocks.indexOf(block);
  var facetKey = getMobileFacetBlockKey(block);

  resetMobileFilterNavigation();

  window._wizzyMobileActiveFacetIndex = facetIndex;
  window._wizzyMobileActiveFacetKey = facetKey;

  applyMobileFilterSubOpenState(block);
}

function reapplyMobileFilterSubOpenState() {
  if (!isMobileFilterDrawer()) return;
  if (!window._wizzyMobileSubOpenActive) return;
  if (!document.body.classList.contains('change-ui-wizzy') &&
      !document.body.classList.contains('wizzy-filters-open')) return;

  var panel = getMobileFilterPanel();
  if (!panel || !panel.classList.contains('wizzy-mobile-drawer-enhanced')) return;

  var block = resolveMobileActiveFacetBlock(panel);
  if (!block) return;

  applyMobileFilterSubOpenState(block);
}

function closeMobileFilterCategory() {
  if (!isMobileFilterDrawer()) return;
  if (window._wizzyMobileFacetClosing) return;

  if (!document.body.classList.contains('wizzy-mobile-filter-sub-open')) {
    resetMobileFilterNavigation();
    syncMobileFilterSummaries();
    return;
  }

  var panel = getMobileFilterPanel();
  var facetBody = panel && panel.querySelector('.wizzy-mobile-facet-stage .wizzy-facet-body');
  if (!facetBody) {
    resetMobileFilterNavigation();
    syncMobileFilterSummaries();
    return;
  }

  window._wizzyMobileFacetClosing = true;
  facetBody.classList.remove('wizzy-mobile-facet-body-open');
  facetBody.classList.add('wizzy-mobile-facet-body-closing');

  window.setTimeout(function () {
    window._wizzyMobileFacetClosing = false;
    resetMobileFilterNavigation();
    syncMobileFilterSummaries();
  }, WIZZY_MOBILE_FACET_SLIDE_MS);
}

function clearMobileActiveFacet() {
  var block = window._wizzyMobileActiveFacetBlock;
  if (!block) return;

  block.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked').forEach(function (input) {
    input.checked = false;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  block.querySelectorAll('input.wizzy-range-input, input[type="number"]').forEach(function (input) {
    input.value = '';
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  block.querySelectorAll('.wizzy-facet-list-item.active').forEach(function (item) {
    item.classList.remove('active');
  });

  syncMobileFilterSummaries();
}

function teardownMobileFilterDrawer() {
  var panel = document.querySelector('.wizzy-search-wrapper .wizzy-search-filters-left.wizzy-mobile-drawer-enhanced') ||
    getMobileFilterPanel();
  if (!panel) return;

  panel.classList.remove('wizzy-mobile-drawer-enhanced');
  resetMobileFilterNavigation();

  var applyBtn = panel.querySelector('.wizzy-apply-all-button');
  var clearBtn = panel.querySelector('.wizzy-filters-close-button');
  if (applyBtn) applyBtn.textContent = 'APPLY';
  if (clearBtn) clearBtn.textContent = 'CLOSE';
}

function bindMobileDrawerFacetHeadCapture() {
  if (window._wizzyMobileHeadCaptureBound) return;
  window._wizzyMobileHeadCaptureBound = true;

  function onFacetHeadInteraction(e) {
    if (window._wizzyMobileFacetHeadHandled) return;
    if (tryOpenMobileFilterCategoryFromTarget(e.target)) {
      window._wizzyMobileFacetHeadHandled = true;
      window.setTimeout(function () {
        window._wizzyMobileFacetHeadHandled = false;
      }, 300);
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }

  document.addEventListener('pointerdown', onFacetHeadInteraction, true);
  // document.addEventListener('click', onFacetHeadInteraction, true);
}

function initMobileFilterDrawer() {
  if (!isMobileFilterDrawer()) return;

  var panel = getMobileFilterPanel();
  if (!panel) return;

  panel.classList.add('wizzy-mobile-drawer-enhanced');
  injectMobileDrawerUI(panel);
  syncMobileFilterSummaries();

  if (window._wizzyMobileDrawerChangeBound) return;
  window._wizzyMobileDrawerChangeBound = true;

  document.addEventListener('change', function (e) {
    if (!isMobileFilterDrawer()) return;
    if (!e.target || !e.target.closest('.wizzy-search-filters-left.wizzy-mobile-drawer-enhanced')) return;
    syncMobileFilterSummaries();
  });

  window.addEventListener('resize', function () {
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(syncMobileDrawerMode);
    } else {
      syncMobileDrawerMode();
    }
  });
}

function syncMobileDrawerMode() {
  if (isMobileFilterDrawer()) {
    initMobileFilterDrawer();
  } else {
    teardownMobileFilterDrawer();
  }
}

function syncMobileV1DrawerState() {
  syncMobileDrawerMode();
  syncMobileFilterSummaries();
}

function syncMobileV2FacetState() {
  if (window.innerWidth <= WIZZY_MOBILE_DRAWER_MAX) {
    syncMobileV1DrawerState();
    return;
  }

  if (window.innerWidth > 989) return;

  var panel = document.querySelector('.wizzy-search-wrapper .wizzy-search-filters-left.wizzy-v2');
  if (!panel) return;

  panel.querySelectorAll('.wizzy-filters-facet-block').forEach(function (block) {
    var body = block.querySelector(':scope > .wizzy-facet-body');
    if (!body) return;

    var inlineDisplay = (body.style.display || '').toLowerCase();
    var isOpen = inlineDisplay === 'block' || inlineDisplay === 'flex';
    block.classList.toggle('wizzy-mobile-facet-open', isOpen);
  });
}

function isMobileSortView() {
  return window.innerWidth <= WIZZY_MOBILE_DRAWER_MAX;
}

function getMobileSortContainer() {
  return document.querySelector('.wizzy-search-sort-wrapper .wizzy-common-select-container');
}

function getMobileSortOptions() {
  var container = getMobileSortContainer();
  if (!container) return [];
  return Array.prototype.slice.call(container.querySelectorAll('.wizzy-common-select-option'));
}

function isMobileSortPanelOpen() {
  return document.body.classList.contains('wizzy-mobile-sort-open');
}

function syncMobileSortBodyOverflow() {
  if (isMobileSortPanelOpen()) {
    document.body.style.overflow = 'hidden';
    return;
  }

  if (!document.body.classList.contains('wizzy-filters-open') &&
      !document.body.classList.contains('change-ui-wizzy')) {
    document.body.style.overflow = '';
  }
}

function clearMobileSortPendingState() {
  getMobileSortOptions().forEach(function (option) {
    option.classList.remove('wizzy-sort-pending', 'wizzy-sort-applied');
  });
  window._wizzyMobileSortPending = null;
}

function syncMobileSortPendingFromSelected() {
  var pending = null;

  getMobileSortOptions().forEach(function (option) {
    option.classList.remove('wizzy-sort-pending', 'wizzy-sort-applied');
    if (option.classList.contains('selected')) {
      pending = option;
    }
  });

  if (pending) {
    pending.classList.add('wizzy-sort-pending');
  }

  window._wizzyMobileSortPending = pending;
}

function setMobileSortPending(option) {
  getMobileSortOptions().forEach(function (item) {
    item.classList.remove('wizzy-sort-pending', 'wizzy-sort-applied');
  });

  if (option) {
    option.classList.add('wizzy-sort-pending');
    window._wizzyMobileSortPending = option;
  }
}

function markMobileSortApplied(option) {
  getMobileSortOptions().forEach(function (item) {
    item.classList.remove('wizzy-sort-applied');
  });

  if (option) {
    option.classList.add('wizzy-sort-applied');
  }
}

function closeMobileSortPanelNative() {
  var container = getMobileSortContainer();
  if (!container) return;

  container.classList.remove('wizzy-mobile-sort-open');

  // Remove classes from <html>
  document.documentElement.classList.remove(
    'wizzy-overlay-opened',
    'wizzy-common-select-body-overlay'
  );

  // Remove classes from <body>
  document.body.classList.remove(
    'wizzy-overlay-opened',
    'wizzy-common-select-body-overlay'
  );

  // Hide the sort options
  var sortOptions = container.querySelector('.wizzy-common-select-options');
  if (sortOptions) {
    sortOptions.style.display = 'none';
  }

  // Hide the overlay
  var sortOverlay = container.querySelector('.wizzy-common-select-overlay');
  if (sortOverlay) {
    sortOverlay.style.display = 'none';
  }

  var sortOverlay = container.querySelector('.wizzy-common-select-overlay');
  if (sortOverlay) {
    sortOverlay.click();
  }
}

var WIZZY_MOBILE_SORT_TICK =
  '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12" fill="none">' +
  '<path d="M16 1.26174L5.02857 12L0 7.0783L1.28914 5.81656L5.02857 9.46756L14.7109 0L16 1.26174Z" fill="black"></path></svg>';

function ensureMobileSortTicks(root) {
  if (!isMobileSortView()) return;
  (root || document).querySelectorAll('.wizzy-search-sort-wrapper .wizzy-mobile-sort-tick:empty').forEach(function (el) {
    el.innerHTML = WIZZY_MOBILE_SORT_TICK;
  });
}

function openMobileSortPanel() {
  if (!isMobileSortView()) return;

  var container = getMobileSortContainer();
  if (!container) return;

  ensureMobileSortTicks(container);
  container.classList.add('wizzy-mobile-sort-open');
  document.body.classList.add('wizzy-mobile-sort-open');
  syncMobileSortPendingFromSelected();
  syncMobileSortBodyOverflow();
}

function closeMobileSortPanel() {
  if (!isMobileSortPanelOpen()) return;

  document.body.classList.remove('wizzy-mobile-sort-open');
  clearMobileSortPendingState();
  closeMobileSortPanelNative();
  syncMobileSortBodyOverflow();
}

function applyMobileSortSelection() {
  if (!isMobileSortView()) return;

  var container = getMobileSortContainer();
  if (!container) {
    closeMobileSortPanel();
    return;
  }

  var pending = window._wizzyMobileSortPending ||
    container.querySelector('.wizzy-common-select-option.wizzy-sort-pending') ||
    container.querySelector('.wizzy-common-select-option.selected');

  if (!pending) {
    closeMobileSortPanel();
    return;
  }

  var currentSelected = container.querySelector('.wizzy-common-select-option.selected');
  markMobileSortApplied(pending);

  if (currentSelected === pending) {
    closeMobileSortPanel();
    return;
  }

  window._wizzyMobileSortApplying = true;
  pending.click();
  window._wizzyMobileSortApplying = false;
  closeMobileSortPanel();
}

function bindMobileSortHandlers() {
  if (window._wizzyMobileSortBound) return;
  window._wizzyMobileSortBound = true;

  document.addEventListener('click', function (e) {
    if (!isMobileSortView()) return;
    if (!e.target || !e.target.closest) return;

    var sortWrapper = e.target.closest('.wizzy-search-sort-wrapper');
    if (!sortWrapper) return;

    if (e.target.closest('.wizzy-mobile-sort-back')) {
      e.preventDefault();
      e.stopPropagation();
      closeMobileSortPanel();
      return;
    }

    if (e.target.closest('.wz-sort-close-icon')) {
      e.preventDefault();
      e.stopPropagation();
      closeMobileSortPanel();
      return;
    }

    if (e.target.closest('.wizzy-mobile-sort-apply')) {
      e.preventDefault();
      e.stopPropagation();
      applyMobileSortSelection();
      return;
    }

    var option = e.target.closest('.wizzy-common-select-option');
    if (option && isMobileSortPanelOpen() && !window._wizzyMobileSortApplying) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      setMobileSortPending(option);
      return;
    }

    if (e.target.closest('.wizzy-common-select-selector')) {
      window.setTimeout(function () {
        if (!isMobileSortView()) return;
        openMobileSortPanel();
      }, 0);
      return;
    }

    if (e.target.closest('.wizzy-common-select-overlay') && isMobileSortPanelOpen()) {
      e.preventDefault();
      e.stopPropagation();
      closeMobileSortPanel();
    }
  }, true);

  window.addEventListener('resize', function () {
    if (!isMobileSortView() && isMobileSortPanelOpen()) {
      closeMobileSortPanel();
    }
  });
}

function afterViewRender(data) {
  buildCategorySidebar();
  updateCollectionTitleAndCount();
  syncWizzyCollectionHero(data);

  // prepareWizzyGridFilterUI();
  // scheduleMobileGridFilterUI();
  // customizeWizzyFilterCheckboxes();
  // formatWizzyFacetCounts();
  // normalizeWizzyPriceFilterCurrency();
  // syncSizeFacetLabelsFromApi();
  applyArabicStaticWizzyUiLabels();
  syncMobileFilterSummaries();
  reapplyMobileFilterSubOpenState();
  ensureMobileSortTicks(document.querySelector('.wizzy-search-wrapper'));

  if (isMobileSortPanelOpen()) {
    document.body.classList.remove('wizzy-mobile-sort-open');
    clearMobileSortPendingState();
    syncMobileSortBodyOverflow();
  }

  if (window._wizzyMobilePendingApplyClose) {
    window._wizzyMobilePendingApplyClose = false;
    closeMobileFilterDrawer({ discard: false });
    window._wizzyMobileFilterSnapshot = snapshotMobileFilterState();
  }

  syncWizzyWishlistAfterRender(); // wishlist: re-sync after Wizzy re-render (clicks stay in global.js)
  loadStampedBadges();
  // scheduleStripRenderedPriceDecimals(document.querySelector('.wizzy-search-wrapper'));

  bindMobileInnerApplyButton();
  bindMobileCloseSvgClose();
  bindSubClearFilterButton();
  bindMobileFacetBackButton();
  bindMobileFacetCloseOnBackAndCloseButton();
  bindMobileFacetClearAllFilters();
  transitionOnHeadClick();
  updatePageWidthStyles();
}


  function isFiltersPanelOpen() {
    return document.body.classList.contains('change-ui-wizzy');
  }

  function syncDesktopFilterToggleLabel() {
    // body.change-ui-wizzy = filters open (desktop sidebar / mobile drawer)
    var filtersVisible = isFiltersPanelOpen();
    var isArabic = isArabicLocale();

    document.querySelectorAll('.wizzy-filters-desktop-toggle-btn').forEach(function (btn) {
      btn.textContent = filtersVisible
        ? (isArabic ? translateToArabic('Hide Filters') : 'Hide Filters')
        : (isArabic ? translateToArabic('Show Filters') : 'Show Filters');
    });
  }

  function ensureDesktopFiltersOpenByDefault() {
    if (window.innerWidth < 990) return;
    if (window._wizzyDesktopFiltersDefaulted) return;
    if (!document.querySelector('.wizzy-search-wrapper.has-left-facets')) return;

    window._wizzyDesktopFiltersDefaulted = true;
    setFiltersPanelOpen(true);
  }

  function setFiltersPanelOpen(isOpen) {
    document.body.classList.toggle('change-ui-wizzy', !!isOpen);

    if (window.innerWidth <= WIZZY_MOBILE_DRAWER_MAX) {
      document.body.classList.toggle('wizzy-filters-open', !!isOpen);
      document.documentElement.classList.toggle('wizzy-overlay-opened', !!isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    } else {
      document.body.classList.remove('wizzy-filters-open');
      document.documentElement.classList.remove('wizzy-overlay-opened');
      document.body.style.overflow = '';
      teardownMobileFilterDrawer();

      if (window.innerWidth <= 989) {
        document.body.classList.toggle('wizzy-filters-open', !!isOpen);
      }
    }

    syncDesktopFilterToggleLabel();
  }

  function toggleDesktopFiltersPanel() {
    setFiltersPanelOpen(!isFiltersPanelOpen());
  }

  function openMobileFiltersPanel() {
    if (isMobileFilterDrawer()) {
      initMobileFilterDrawer();
      resetMobileFilterNavigation();
      window._wizzyMobileFilterSnapshot = snapshotMobileFilterState();
    }
    setFiltersPanelOpen(true);
  }

  function closeMobileFilterDrawer(options) {
    options = options || {};

    if (isMobileFilterDrawer()) {
      if (options.discard && window._wizzyMobileFilterSnapshot) {
        restoreMobileFilterSnapshot(window._wizzyMobileFilterSnapshot);
      }
      resetMobileFilterNavigation();
      document.body.style.overflow = '';
    }

    setFiltersPanelOpen(false);

    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(syncMobileV2FacetState);
    }
  }

  function closeFiltersPanel() {
    closeMobileFilterDrawer({ discard: false });
  }

  function bindFilterUiHandlers() {
    if (window._wizzyCustomFilterUiBound) return;
    window._wizzyCustomFilterUiBound = true;

    document.addEventListener('click', function (e) {
      var target = e.target;
      if (!target || !target.closest) return;

      // Desktop Show / Hide Filters button — direct toggle (no fake header click)
      var toggleWrapper = target.closest('.wizzy-top-filter-btn-wrapper');
      var toggleBtn = target.closest('.wizzy-filters-desktop-toggle-btn');
      if (toggleWrapper || toggleBtn) {
        e.preventDefault();
        e.stopPropagation();
        toggleDesktopFiltersPanel();
        return;
      }

      // Toolbar filter button
      var toolbarBtn = target.closest('.wizzy-toolbar-filter-btn');
      if (toolbarBtn) {
        e.preventDefault();
        e.stopPropagation();
        if (window.innerWidth > 989) {
          toggleDesktopFiltersPanel();
        } else {
          openMobileFiltersPanel();
        }
        return;
      }

      // Mobile filters entry (top bar + drawer button)
      var mobileEntry = target.closest('.wizzy-filters-mobile-entry, .wizzy-filters-desktop-entry');
      if (mobileEntry) {
        e.preventDefault();
        e.stopPropagation();
        if (window.innerWidth > 989) {
          toggleDesktopFiltersPanel();
        } else {
          openMobileFiltersPanel();
        }
        return;
      }

      // Mobile two-level drawer (<=668px only)
      if (isMobileFilterDrawer()) {
        var enhancedPanel = target.closest('.wizzy-search-filters-left.wizzy-mobile-drawer-enhanced');
        if (enhancedPanel) {
          if (target.closest('.wizzy-mobile-subfilter-back')) {
            e.preventDefault();
            e.stopPropagation();
            closeMobileFilterCategory();
            return;
          }

          if (target.closest('.wizzy-mobile-main-back, .wizzy-filters-close-btn, .wizzy-mobile-subfilter-close')) {
            e.preventDefault();
            e.stopPropagation();
            closeMobileFilterDrawer({ discard: true });
            return;
          }

          if (target.closest('.wizzy-filters-bg')) {
            e.preventDefault();
            e.stopPropagation();
            closeMobileFilterDrawer({ discard: true });
            return;
          }

          if (target.closest('.wizzy-filters-close-button')) {
            e.preventDefault();
            e.stopPropagation();
            if (document.body.classList.contains('wizzy-mobile-filter-sub-open')) {
              clearMobileActiveFacet();
            } else {
              var clearAll = enhancedPanel.querySelector('.wizzy-filters-clear-all');
              if (clearAll) {
                clearAll.click();
              } else {
                getMobileFilterFacetBlocks(enhancedPanel).forEach(function (block) {
                  window._wizzyMobileActiveFacetBlock = block;
                  clearMobileActiveFacet();
                });
                window._wizzyMobileActiveFacetBlock = null;
              }
              syncMobileFilterSummaries();
            }
            return;
          }

          if (target.closest('.wizzy-apply-all-button')) {
            // Close sub-category UI if open, but never block Wizzy's native apply.
            // Do not preventDefault/stopPropagation or re-dispatch — that breaks apply.
            if (document.body.classList.contains('wizzy-mobile-filter-sub-open')) {
              closeMobileFilterCategory();
            }
            window._wizzyMobilePendingApplyClose = true;
            return;
          }

          var facetItem = target.closest('.wizzy-facet-list-item');
          if (facetItem && document.body.classList.contains('wizzy-mobile-filter-sub-open') && !target.closest('input')) {
            var itemCheckbox = facetItem.querySelector('input[type="checkbox"], input[type="radio"]');
            if (itemCheckbox) {
              e.preventDefault();
              e.stopPropagation();
              itemCheckbox.checked = !itemCheckbox.checked;
              itemCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
              itemCheckbox.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
              facetItem.classList.toggle('active', itemCheckbox.checked);
              syncMobileFilterSummaries();
              return;
            }
          }
        }
      }

      // Close controls (tablet / fallback — not enhanced mobile drawer)
      if (target.closest('.wizzy-filters-close-btn, .wizzy-filters-close-button, .wizzy-filters-bg')) {
        closeFiltersPanel();
        return;
      }

      // Facet head sync for tablet v2 fallback only
      if (target.closest('.wizzy-search-wrapper .wizzy-facet-head')) {
        if (isMobileFilterDrawer() && document.querySelector('.wizzy-search-wrapper .wizzy-search-filters-left.wizzy-mobile-drawer-enhanced')) {
          return;
        }
        if (typeof requestAnimationFrame === 'function') {
          requestAnimationFrame(syncMobileV2FacetState);
        }
        window.setTimeout(syncMobileV2FacetState, 60);
      }
    });
  }

  var _wizzyViewRenderSyncTimer = null;
  var _wizzyViewRenderSyncPayload = null;
  var _wizzyProductTransformContext = 'search';

  function isWizzyAutocompleteRender(data) {
    return !!(data && data.api === 'autocomplete');
  }

  function afterViewRenderWithFilterSync(data) {
    window._wizzyLastRenderPayload = data;
    afterViewRender(data);
    ensureDesktopFiltersOpenByDefault();
    syncDesktopFilterToggleLabel();
    syncWizzyPaginationProgress(data);
  }

  function scheduleAfterViewRenderWithFilterSync(data) {
    if (isWizzyAutocompleteRender(data)) {
      // scheduleStripRenderedPriceDecimals(getWizzyAutocompleteWrapper(), true);
      return;
    }

    _wizzyViewRenderSyncPayload = data;
    if (_wizzyViewRenderSyncTimer) {
      window.clearTimeout(_wizzyViewRenderSyncTimer);
    }
    _wizzyViewRenderSyncTimer = window.setTimeout(function () {
      _wizzyViewRenderSyncTimer = null;
      afterViewRenderWithFilterSync(_wizzyViewRenderSyncPayload);
    }, 16);
  }

  function applyWizzyInitConfig(data) {
    data.store.currency.symbol = "AED ";
    if(window.Shopify.locale == "ar") {
      // console.log("Wizzy Switched Arabic")
        window.wizzyConfig.credentials = {
        "apiKey": "cjQ2QWpyRTlTZ1BBY0tmbFFnNStjcnZPaFVMKzR0RTRMYkFsOGVUYU90VlAxbTdXRytXclA5dmtuT3U2dVFyOE01Mk9DeG5BVHd4aVhxSm9SWjcwMnc9PQ==",
        "storeId": WIZZY_ARABIC_STORE_ID
      }
      initializeArabicTranslationMap();
      // applyArabicSortConfigLabels();
      translateWizzyConfigToArabic(data);

      data.store.currency.symbol = "درهم ";
    }
    data.search.configs.pagination.appendInExistingList = true;
    window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
      desktop: 2000,
      mobile: 1000
    };
    data.filters.configs.keepOpenedInMobileAfterApply = true;
    // data.filters.configs.layout = 'v1';

    if (data && data.store && data.store.products) {
      data.store.products.displayAddToCart = false;
    }

    data.search.configs.facets.showPriceInputRangeFields = true;

    return data;
  }

  bindFilterUiHandlers();
  bindGridFilterResizeHandler();
  bindMobileDrawerFacetHeadCapture();
  bindMobileSortHandlers();
  // bindAutocompletePriceDecimalStrip();
  // removeBrackets();
  var events = window.wizzyConfig && window.wizzyConfig.events;
  if (!events || !events.allowedEvents) return;
  var allowed = events.allowedEvents;

  events.registerEvent(allowed.BEFORE_INIT, applyWizzyInitConfig);
  events.registerEvent(allowed.BEFORE_LAZY_INIT, applyWizzyInitConfig);

  events.registerEvent(allowed.BEFORE_SEARCH_EXECUTED, function (data) {
    var alreadyAdded = data.sort.some(
      (s) => s.field === "sellingPrice"
    );
    if (!alreadyAdded) {
      var oldSort = data.sort;
      var sellingPriceVariantSort = { field: "sellingPrice", order: "asc", isForParent: false, isForVariation: true };
      oldSort.push(sellingPriceVariantSort);
      data.sort = oldSort;
    }

    var breadCrumb = document.querySelector('.wizzy-search-results-rendered #MainContent .page-width .breadcrumbs');
    if (breadCrumb) {
      breadCrumb.style.display = 'none';
    }

    var PDPContent = document.querySelector('product-modal');
    if (PDPContent) {
      PDPContent.style.display = 'none';
    }

    // if (isOutletSite()) {
    //   data.rankingRules = JSON.stringify([
    //     {
    //       match: "all",
    //       purpose: "include",
    //       rules: [
    //         {
    //           field: "attributes",
    //           attribute: "product_outlet_custom",
    //           type: "string",
    //           matchType: "any",
    //           expectedValues: ["Yes"]
    //         }
    //       ]
    //     }
    //   ]);
    // }

    var mainContent = document.querySelector(
      '.wizzy-search-results-rendered #MainContent'
    );

    if (mainContent) {
      var sections = mainContent.querySelectorAll('.shopify-section');

      sections.forEach(function (section) {
        if (section.querySelector('.wizzy-search-wrapper')) {
        } else {
          section.style.display = 'none';
        }
      });
    }

    return data;
  }, 1);

  events.registerEvent(allowed.BEFORE_FILTERS_EXECUTED, function (data) {
    data.filters.attributeFacetValuesLimit = 250;

    if (data && data.filters && data.filters.type && data.filters.type === "CATEGORY_PAGE") {
      if (isOutletSite()) {
        data.rankingRules = JSON.stringify([
          {
            match: "all",
            purpose: "include",
            rules: [
              {
                field: "attributes",
                attribute: "product_outlet_custom",
                type: "string",
                matchType: "any",
                expectedValues: ["Yes"]
              }
            ]
          }
        ]);
      } else {
        data.rankingRules = JSON.stringify([
          {
            match: "all",
            purpose: "include",
            rules: [
              {
                field: "attributes",
                attribute: "product_outlet_custom",
                type: "string",
                matchType: "any",
                expectedValues: ["No"]
              }
            ]
          }
        ]);
      }
    }

    if (data && data.filters && data.filters.sort && data.filters.sort.length > 0 && data.filters.sort[0].field !== "sellingPrice") {
      var alreadyAdded = data.filters.sort.some(
        (s) => s.field === "sellingPrice"
      );
      if (!alreadyAdded) {
        var oldSort = data.filters.sort;
        if (data.filters.type && data.filters.type === "CATEGORY_PAGE") {
          var collectionSort = {field: "product_"+window.wizzyConfig.common.collectionHandle+"_sortOrder:float", order: 'asc'};
          oldSort.push(collectionSort);
        }
        var sellingPriceVariantSort = { field: "sellingPrice", order: "asc", isForParent: false, isForVariation: true };
        oldSort.push(sellingPriceVariantSort);
        data.filters.sort = oldSort;
      }
    }

    return data;
  });

  events.registerEvent(allowed.BEFORE_RENDER_RESULTS, function (data) {
    if (data.api === 'autocomplete') {
      _wizzyProductTransformContext = 'autocomplete';
    } else if (data.api === 'search' || data.api === 'filter') {
      _wizzyProductTransformContext = 'search';
    }

    if (data.api === 'search' || data.api === 'filter') {
      var facets = data && data.response && data.response.payload && data.response.payload.facets;
      if (facets) {
        facets.forEach(function (facet) {
          if (isWizzySizeFacetKey(facet.key)) {
            // ensureWizzySizeFacetEnglishLabels(facet);
          }

          if (!isWizzySizeFacetKey(facet.key) && isWizzyColorFacetKey(facet.key) && Array.isArray(facet.data)) {
            facet.data.forEach(function (item) {
              var color = findHaxCode(item.key);
              item.isSwatch = true;
              item.isURLSwatch = color[1];
              item.isVisualSwatch = true;
              item.swatchValue = color[0];
              item.data = {
                value: item.key,
                swatch: {
                  type: 'visual',
                  value: color[0]
                }
              };
              item.label = isArabicLocale() ? translateColorsToArabic(item.label) : item.label;
            });
          }
        });
      }
    }

    return data;
  });

  if (allowed.BEFORE_AUTOCOMPLETE_PRODUCTS_RENDER) {
    events.registerEvent(allowed.BEFORE_AUTOCOMPLETE_PRODUCTS_RENDER, function (data) {
      _wizzyProductTransformContext = 'autocomplete';
      if (data && Array.isArray(data.products)) {
        // normalizeWizzyProductsPriceList(data.products);
      }
      return data;
    });
  }
   
  function removeBrackets() {
    document.querySelectorAll('.wizzy-facet-list-item-count').forEach(el => {
        el.textContent = el.textContent.replace(/[()]/g, '');
    });
}

  events.registerEvent(allowed.AFTER_PRODUCTS_TRANSFORMED, function (products) {
    // console.log("Wizzy after event top", products);
    // if (_wizzyProductTransformContext === 'autocomplete') {
    //   // (products || []).forEach(normalizeWizzyProductPriceFields);
    //   _wizzyProductTransformContext = 'search';
    //   return products;
    // }

    try {
      (products || []).forEach(function (product) {
        // normalizeWizzyProductPriceFields(product);

        if (typeof product.attributes === 'undefined') {
          product.attributes = [];
        }

        product.displayAddToCart = false;
        product.shopifyProductId = '';
        product.productType = product.type || product.productType || '';
        product.vendor = product.vendor || '';

        // wishlist: ensure [[handle]] is set for data-handle on Wizzy cards (search API may omit it)
        if (!product.handle && product.url) {
          var handleMatch = String(product.url).match(/\/products\/([^/?#]+)/);
          if (handleMatch) {
            product.handle = handleMatch[1];
          }
        }
        product.jugdemeReview = "<div style='display:none' class='jdgm-prev-badge' data-average-rating='0.00' data-number-of-reviews='0' data-number-of-questions='0'> <span class='jdgm-prev-badge__stars' data-score='0.00' tabindex='0' aria-label='0.00 stars' role='button'> <span class='jdgm-star jdgm--off'></span><span class='jdgm-star jdgm--off'></span><span class='jdgm-star jdgm--off'></span><span class='jdgm-star jdgm--off'></span><span class='jdgm-star jdgm--off'></span> </span> <span class='jdgm-prev-badge__text'> No reviews </span> </div>";

        if (product.gid && product.gid.indexOf('Product/') > -1) {
          product.shopifyProductId = product.gid.split('Product/')[1];
        }

        product.attributes.forEach(function (attribute) {
          var id = attribute.id || '';
          var lowerId = id.toLowerCase();
          var firstValue = attribute.values && attribute.values[0] && attribute.values[0].value ? attribute.values[0].value[0] : null;

          if (id === 'product_technologies_images_custom' && firstValue) {
            product.techImage = firstValue.split('||')[0];
          }

          if (id === 'product_badge_judgeme' && firstValue) {
            product.jugdemeReview = firstValue;
          }

          if (id === 'product_value_tags_labels' && firstValue) {
            product.valueLabel = firstValue;
          }

          // Wizzy docs: map product_vendor attribute for [[vendor]] on SLP/PLP cards
          if (!product.vendor && firstValue && (id === 'product_vendor' || lowerId.indexOf('vendor') > -1)) {
            product.vendor = firstValue;
          }

          // if (id === 'product_store_codes' && firstValue) {
          //   var codeValues = firstValue;
          //   try {
          //     codeValues = JSON.parse(codeValues);
          //   } catch (err) {
          //     console.error('Wizzy Express Invalid store codes JSON', err);
          //     codeValues = null;
          //   }

          //   if (codeValues) {
          //     var userPincode = sessionStorage.getItem('storage_pincode');
          //     if (userPincode && window.expressPincodeMappings) {
          //       var mappingEntry = window.expressPincodeMappings.find(function (entry) {
          //         return entry.pincode == userPincode;
          //       });

          //       if (mappingEntry) {
          //         var storePriority = Object.keys(mappingEntry)
          //           .filter(function (key) { return key.indexOf('storeCode') === 0; })
          //           .sort(function (a, b) { return a.localeCompare(b); })
          //           .map(function (key) { return mappingEntry[key]; })
          //           .filter(function (code) { return !!code; });

          //         for (var i = 0; i < storePriority.length; i++) {
          //           var storeCode = storePriority[i];
          //           if (codeValues[storeCode] && codeValues[storeCode] > 0) {
          //             product.expressDeliveryEligible = true;
          //             break;
          //           }
          //         }
          //       }
          //     }
          //   }
          // }

          if (firstValue !== null && firstValue !== undefined) {
            if (lowerId.indexOf('product_id') > -1 || lowerId.indexOf('shopify_product') > -1 || lowerId === 'id') {
              product.shopifyProductId = String(firstValue).replace(/\D/g, '');
            }
            if (lowerId.indexOf('product_type') > -1 || lowerId === 'type') {
              product.productType = firstValue;
            }
            if (lowerId.indexOf('review_count') > -1 || lowerId.indexOf('reviews_count') > -1 || lowerId.indexOf('total_review') > -1) {
              product.totalReviews = firstValue;
            }
            if ((lowerId.indexOf('rating') > -1 || lowerId.indexOf('review') > -1 || lowerId.indexOf('stamped') > -1) &&
                !isNaN(parseFloat(firstValue)) && lowerId.indexOf('count') === -1 && lowerId.indexOf('total') === -1) {
              product.avgRatings = parseFloat(firstValue).toFixed(1);
            }
          }

          if (id === "product_brand_custom" && firstValue) {
            product.actualBrand = firstValue;
          }

          if (id === "product_outlet_custom" && firstValue) {
            if (firstValue === "Yes") {
              product.isOutlet = true;
            }
          }

          if (id === "product_promotional_code_custom" && firstValue) {
            product.promotionalCode = firstValue;
          }

          if (id === "product_variant_ids" && firstValue && attribute.values.length === 1) {
            if (product.groupId === "" && !product.singleVariantGroupId) {
              product.singleVariantGroupId = product.id;
              product.id = firstValue;
            }
          }
        });

        // Fallback: Brand_ tags (same source as theme card-product.liquid)
        if (!product.vendor) {
          var productTags = getWizzyProductTags(product);
          for (var t = 0; t < productTags.length; t++) {
            if (productTags[t].indexOf('Brand_') === 0) {
              product.vendor = productTags[t].replace('Brand_', '');
              break;
            }
          }
        }

        // Fallback: Wizzy brands array if present
        if (!product.vendor && Array.isArray(product.brands) && product.brands.length) {
          var brandEntry = product.brands[0];
          product.vendor = typeof brandEntry === 'string'
            ? brandEntry
            : (brandEntry.value || brandEntry.label || brandEntry.name || '');
        }

        if (!product.shopifyProductId) {
          product.shopifyProductId = product.product_id || product.groupId || product.productId || '';
        }

        if (!product.avgRatings && product.ratings) product.avgRatings = parseFloat(product.ratings).toFixed(1);
        if (!product.avgRatings && product.avgRating) product.avgRatings = parseFloat(product.avgRating).toFixed(1);
        if (!product.totalReviews && product.reviewsCount) product.totalReviews = product.reviewsCount;
        if (!product.totalReviews && product.totalReviewCount) product.totalReviews = product.totalReviewCount;

        // console.log("Wizzy swatches", product.swatches);
        if (product.swatches && product.swatches.length) {
          var colorGroup = product.swatches.find(function (s) {
            var key = (s.key || '').toLowerCase();
            return key.indexOf('color') > -1 || key.indexOf('colour') > -1;
          }) || product.swatches[0];
          var count = (colorGroup.values || []).length;
          if (count > 1) {
            product.colorCountLabel = count + ' ' + (
              isArabicLocale()
                ? translateToArabic('Colors')
                : 'Colors'
            );
          }
        }

        if (product.discountPercentage) {
          product.saveBadge = 'SAVE ' + Math.round(product.discountPercentage) + '%';
        }

        var tagBadge = resolveTagBadgeLabel(getWizzyProductTags(product));
        if (!tagBadge && product.valueLabel) {
          tagBadge = normalizeValueTagLabel(product.valueLabel);
        }
        if (tagBadge) {
          product.tagBadge = tagBadge;
          product.showTagBadge = true;
        }

        product.price = removePriceDecimals(product.price);
        product.sellingPrice = removePriceDecimals(product.sellingPrice);

        if (product.price > product.sellingPrice) {
          product.showSaleBadge = true;
          product.saleBadgeText = isArabicLocale() ? 'تخفيض' : 'Sale';
        }

        var reviewCount = parseInt(product.totalReviews, 10);
        if (isNaN(reviewCount)) reviewCount = 0;
        var hasRating = product.avgRatings && parseFloat(product.avgRatings) > 0;

        if (reviewCount > 0 || hasRating) {
          product.showReviews = true;
          product.starsHtml = buildStarsHtml(product.avgRatings);

          var isArabic = isArabicLocale();
          var reviewText = isArabic ? translateToArabic('Review') : 'Review';
          var reviewsText = isArabic ? translateToArabic('Reviews') : 'Reviews';

          if (reviewCount === 1) {
            product.reviewLabel = '1 ' + reviewText;
          } else if (reviewCount > 1) {
            product.reviewLabel = reviewCount + ' ' + reviewsText;
          } else {
            product.reviewLabel = '1 ' + reviewText;
          }
        }

        if (isArabicLocale()) {
          product.url = getArabicProductUrl(product.url);
        }

        product.quickAddUrl = buildWizzyQuickAddUrl(product.url);

        // console.log("Wizzy after", products);
      });
    } catch (e) {
      console.log("wizzy error", e);
    }

    return products;
  }, 1);

  events.registerEvent(allowed.VIEW_RENDERED, function (data) {
    scheduleAfterViewRenderWithFilterSync(data);
    // console.log("Wizzy VIEW_RENDERED", data);

    var total = data.data?.response?.payload?.total;
    if (total) {
      updateProductsCount(total);
    }
    
    moveWizzyQuickAddModalsToBody();

    resetWizzySearchSectionPadding();

    updateCollectionHeadingProductCount();

    return data;
  });

  if (allowed.PRODUCTS_RESULTS_RENDERED) {
    events.registerEvent(allowed.PRODUCTS_RESULTS_RENDERED, function (data) {
      scheduleAfterViewRenderWithFilterSync(data);
      return data;
    });
  }

  events.registerEvent(allowed.PRODUCTS_CACHED_RESULTS_RENDERED, function (data) {
    document.body.classList.add('wizzy-search-results-rendered');
    scheduleAfterViewRenderWithFilterSync(data);

    var total = window.wizzyConfig?.pageStore?.searchedResponse?.total; 

    if (total) {
      updateProductsCount(total);
    }

    moveWizzyQuickAddModalsToBody();

    resetWizzySearchSectionPadding();

    updateCollectionHeadingProductCount();

    return data;
  });

  if (allowed.EMPTY_RESULTS_RENDERED) {
    events.registerEvent(allowed.EMPTY_RESULTS_RENDERED, function (data) {
      scheduleAfterViewRenderWithFilterSync(data);
      return data;
    });
  }

  if (allowed.AFTER_WIZZY_API_RESPONDED) {
    events.registerEvent(allowed.AFTER_WIZZY_API_RESPONDED, function (data) {
      // data = applyWizzySizeFacetLabelFixes(data);
      // return applyArabicLabelsToWizzyApiResponse(data);
      return data;
    });
  }

  if (allowed.AFTER_WIZZY_API_RESPONDED) {
    events.registerEvent(allowed.AFTER_WIZZY_API_RESPONDED, function (data) {
      // console.log("wizzy AFTER_WIZZY_API_RESPONDED", data);

      if (data.api === "filter") {
        var reqType = data.response?.payload?.filters?.type;

        if (reqType === "AUTOCOMPLETE_DEFAULT") {
          var results = data.response?.payload?.result; 

          if (results && results.length > 0) {
            data.response.payload.result = [];
          }
        }
      }

      return data;
    });
  }

  if (allowed.BEFORE_AUTOCOMPLETE_PRODUCTS_RENDER) {
    events.registerEvent(allowed.BEFORE_AUTOCOMPLETE_PRODUCTS_RENDER, function (data) {
      // console.log("wizzy BEFORE_AUTOCOMPLETE_PRODUCTS_RENDER", data);
      if (data.isForDefault) {
        data.products = [];
      }
      return data;
    });
  }

  if (allowed.BEFORE_AUTOCOMPLETE_SUGGESTIONS_RENDER) {
    events.registerEvent(allowed.BEFORE_AUTOCOMPLETE_SUGGESTIONS_RENDER, function (data) {
      // console.log("wizzy BEFORE_AUTOCOMPLETE_SUGGESTIONS_RENDER", data);
      data.groupedSuggestions = groupSuggestions(
        data.suggestions,
        data.isForDefault
      );

      if (data.isForEmptyResult) {
        data.displayNoResults = true;
      }
      return data;
    });
  }

  if (allowed.BEFORE_AUTOCOMPLETE_EXECUTED) {
    events.registerEvent(allowed.BEFORE_AUTOCOMPLETE_EXECUTED, function (data) {
      // if (isOutletSite()) {
      //   data.rankingRules = JSON.stringify([
      //     {
      //       match: "all",
      //       purpose: "include",
      //       rules: [
      //         {
      //           field: "attributes",
      //           attribute: "product_outlet_custom",
      //           type: "string",
      //           matchType: "any",
      //           expectedValues: ["Yes"]
      //         }
      //       ]
      //     }
      //   ]);
      // }

      // console.log("Wizzy BEFORE_AUTOCOMPLETE_EXECUTED", data)

      // var alreadyAdded = data.sort.some(
      //   (s) => s.field === "sellingPrice"
      // );
      // if (!alreadyAdded) {
        var oldSort = [];
        var relevanceSort = {field: "relevance", order: "asc"};
        var sellingPriceVariantSort = { field: "sellingPrice", order: "asc", isForParent: false, isForVariation: true };
        oldSort.push(relevanceSort);
        oldSort.push(sellingPriceVariantSort);
        data.sort = oldSort;
      // }
      return data;
    });
  }
}

window.onWizzyLoaded = window.onWizzyLoaded || [];
window.onWizzyLoaded.push(initWizzyCustom);

function bindStageFacetItems() {
  document
    .querySelectorAll('.wizzy-mobile-facet-stage .wizzy-facet-list-item')
    .forEach(function (item) {

      if (item.dataset.stageBound) return;
      item.dataset.stageBound = "1";

      item.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        var dataKey = item.getAttribute("data-key");

        var originalItem = document.querySelector(
          '.wizzy-facet-list-block .wizzy-facet-list-item[data-key="' +
          dataKey +
          '"]'
        );

        if (originalItem) {
          originalItem.click();
        }
      });
    });
}

function bindMobileInnerApplyButton() {
  if (window._wizzyMobileApplyCloseBound) return;
  window._wizzyMobileApplyCloseBound = true;

  document.addEventListener('click', function (e) {
    var innerApplyButton = e.target.closest('.wz-filter-apply-sub-button');
    if (!innerApplyButton) return;

    var applyButton = document.querySelector('.wizzy-search-filters-left.wizzy-v2 .wizzy-mobile-filter-buttons .wizzy-apply-all-button');
    if (applyButton) {
      applyButton.click();
    }
  });
}

function bindMobileCloseSvgClose() {
  if (window._wizzyMobileSvgCloseBound) return;
  window._wizzyMobileSvgCloseBound = true;

  document.addEventListener('click', function (e) {
    var svgButton = e.target.closest('.wizzy-overlay-opened.wizzy-filters-overlay .wizzy-search-filters-left.wizzy-v2 button.mobile-facets__close-button .mobile-facets__close');
    if (!svgButton) return;

    var overlay = document.querySelector('.wizzy-filters-bg');
    if (overlay) {
      overlay.click();
    }
  });
}

function bindSubClearFilterButton() {
  if (window._wizzySubClearFilterBound) return;
  window._wizzySubClearFilterBound = true;

  document.addEventListener('click', function (e) {
    var innerSubClearButton = e.target.closest('.wz-sub-clear-filter-button');
    if (!innerSubClearButton) return;

    e.preventDefault();

    // Find the current facet body
    var facetBody = innerSubClearButton.closest('.wizzy-facet-body');
    if (!facetBody) return;

    // Get all active items only within this facet body
    var activeItems = facetBody.querySelectorAll('.wizzy-facet-list-item.active');

    activeItems.forEach(function (item) {
      item.click();
    });

    // Click the Apply Filters button for this facet body
    var applyButton = facetBody.querySelector('.wz-filter-apply-sub-button');
    if (applyButton) {
      applyButton.click();
    }
  });
}

function bindMobileFacetBackButton() {
  if (window._wizzyMobileFacetBackBound) return;
  window._wizzyMobileFacetBackBound = true;

  document.addEventListener('click', function (e) {
    var button = e.target.closest('.wizzy-facet-body .mobile-facets__close-button');
    if (!button) return;

    // Only proceed if the click was on the first SVG (back arrow)
    var firstSvg = button.querySelector('svg:first-of-type');
    if (!firstSvg || !firstSvg.contains(e.target)) {
      return;
    }

    var selectedFacetHead = document.querySelector('.wizzy-facet-head.wizzy-selected-facet');
    if (selectedFacetHead) {
      selectedFacetHead.classList.remove('wizzy-selected-facet');
    }

    var facetBody = button.closest('.wizzy-facet-body');
    if (facetBody) {
      facetBody.style.display = 'none';
    }
  });
}

function bindMobileFacetCloseOnBackAndCloseButton() {
  if (window._wizzyMobileFacetCloseOnBackAndCloseButtonBound) return;
  window._wizzyMobileFacetCloseOnBackAndCloseButtonBound = true;

  document.addEventListener('click', function (e) {
    var svgButton = e.target.closest('.wizzy-overlay-opened.wizzy-filters-overlay .wizzy-search-filters-left.wizzy-v2 .wizzy-filters-header .mobile-facets__close');
    if (!svgButton) return;

    var overlay = document.querySelector('.wizzy-filters-bg');
    if (overlay) {
      overlay.click();
    }
  });
}

function bindMobileFacetClearAllFilters() {
  if (window._wizzyMobileFacetClearAllFiltersBound) return;
  window._wizzyMobileFacetClearAllFiltersBound = true;

  document.addEventListener('click', function (e) {
    var clearAllFiltersButton = e.target.closest('.wizzy-overlay-opened.wizzy-filters-overlay .wizzy-search-filters-left.wizzy-v2 .wz-clear-all-filter-button');
    if (!clearAllFiltersButton) return;

    var actualClearAllButton = document.querySelector('.wizzy-filters-clear-all');
    if (actualClearAllButton) {
      actualClearAllButton.click();
    } else {
      var overlay = document.querySelector('.wizzy-filters-bg');
      if (overlay) {
        overlay.click();
      }
    }

    // var overlay = document.querySelector('.wizzy-filters-bg');
    // if (overlay) {
    //   overlay.click();
    // }
  });
}

function transitionOnHeadClick() {
  // if (window._wizzyTransitionOnHeadClickBound) return;
  // window._wizzyTransitionOnHeadClickBound = true;

  // console.log("Wizzy transitionOnHeadClick");

  // document.addEventListener('click', function (e) {
  //   console.log("Wizzy e", e);

  //   var facetHead = e.target.closest(
  //       '.wizzy-overlay-opened.wizzy-filters-overlay .wizzy-search-filters-left.wizzy-v2 .wizzy-facet-head'
  //   );

  //   if (!facetHead) return;

  //   var facetBlock = facetHead.closest('.wizzy-filters-facet-block');
  //   if (!facetBlock) return;

  //   var facetBody = facetBlock.querySelector('.wizzy-facet-body');
  //   if (facetBody) {
  //       facetBody.classList.add('wizzy-selected-facet-body');
  //   }

  // }, true);
}

function updatePageWidthStyles() {
  var wrapper = document.getElementById('wizzy-shopify-collection-page-wrapper');

  if (!wrapper) {
    return;
  }

  var mainContent = wrapper.closest('#MainContent');

  if (!mainContent) {
    return;
  }

  // Update the parent .page-width containing the wrapper
  var pageWidth = wrapper.closest('.page-width');

  if (pageWidth && mainContent.contains(pageWidth)) {
    pageWidth.style.setProperty('padding', '0', 'important');
    pageWidth.style.setProperty('max-width', '100%', 'important');
  }

  // Update the .apps_section inside the same #MainContent
  var appsSection = mainContent.querySelector('.apps_section');

  if (appsSection) {
    appsSection.style.setProperty('background', '#fff', 'important');
  }
}

function updateProductsCount(total) {
  var productsCount = document.querySelector('.wizzy-products-count');

  if (!productsCount) {
    return;
  }

  try {
    var label = isArabicLocale()
      ? translateToArabic('items found')
      : 'items found';

    productsCount.innerHTML =
      '<span class="wizzy-products-count-number">' +
      (total || 0) +
      '</span> ' +
      '<span class="wizzy-products-count-label">' +
      label +
      '</span>';
  } catch (e) {
    console.error('Wizzy Translation error:', e);
  }
}

function removePriceDecimals(value) {
    if (value === null || value === undefined || value === '') {
        return value;
    }

    return String(value).replace(/(\d[\d,]*)\.\d+/g, '$1');
}

function buildWizzyQuickAddUrl(productUrl) {
  var path = getProductPathname(productUrl);

  if (isArabicLocale()) {
    // duplicate theme path
    // return '/ar' + path + '?section_id=quick-add-product';
    // Live theme path
    return  path + '?section_id=quick-add-product';
  }

  return path + '?section_id=quick-add-product';
}

function getProductPathname(productUrl) {
  var path = '/';

  try {
    path = new URL(String(productUrl), window.location.origin).pathname || '/';
  } catch (err) {
    path = String(productUrl || '/').split('#')[0].split('?')[0] || '/';
  }

  if (path.charAt(0) !== '/') path = '/' + path;
  if (path === '/ar') path = '/';
  else if (path.indexOf('/ar/') === 0) path = path.slice(3) || '/';

  return path;
}

function moveWizzyQuickAddModalsToBody() {
  document.querySelectorAll('li.wizzy-result-product quick-add-modal').forEach(function (modal) {
    if (modal.parentElement === document.body) return;
    document.body.appendChild(modal);
  });
}

function resetWizzySearchSectionPadding() {
  var mainContent = document.querySelector(
    '.wizzy-search-results-rendered #MainContent'
  );

  if (mainContent) {
    var sections = mainContent.querySelectorAll('.shopify-section');

    sections.forEach(function (section) {
      if (section.querySelector('.wizzy-search-wrapper')) {
        section.style.padding = '0';
      }
    });
  }
}

/**
 * Fill collection heading product count once from VIEW_RENDERED payload.total.
 * Applies only when .wizzy-collection-product-count exists and is still empty.
 */
function updateCollectionHeadingProductCount() {
  var countEl = document.querySelector('.wizzy-collection-product-count');
  var payload = null;

  if (window.wizzyConfig?.pageStore?.searchedResponse) {
    payload = window.wizzyConfig.pageStore.searchedResponse;
  }

  if (
    countEl &&
    String(countEl.textContent || '').trim() === '' &&
    payload &&
    payload.total != null
  ) {
    countEl.textContent = payload.total;

    var wrapper = countEl.closest('.products-count-wrappers');
    if (wrapper) {
      wrapper.removeAttribute('hidden');
      wrapper.style.display = '';
    }
  }
}

function groupSuggestions(suggestions, isForDefault) {
  var groupedSuggestions = [];
  var currentGroup = null;

  suggestions.forEach(function (item) {
    if (item.isHead) {
      currentGroup = {
        title: item.label,
        group: item.group,
        index: item.index,
        isForDefault: isForDefault,

        // Useful identifiers
        sectionClass: "section-" + item.group,
        itemClass: "item-" + item.group,

        isPopularSearches: item.group === "others",
        isPopularBrands: item.group === "brands",
        isRecentSearches: item.group === "recent",
        isTrendingSearches: item.group === "trending",

        suggestions: []
      };

      groupedSuggestions.push(currentGroup);
    } else if (currentGroup) {
      item.sectionClass = currentGroup.sectionClass;
      item.itemClass = currentGroup.itemClass;

      currentGroup.suggestions.push(item);
    }
  });

  // Reorder the sections
  groupedSuggestions.sort(function (a, b) {
      var order = {
          others: 0,    // Popular Searches
          brands: 1,    // Popular Brands
      };

      var aOrder = order.hasOwnProperty(a.group) ? order[a.group] : 999;
      var bOrder = order.hasOwnProperty(b.group) ? order[b.group] : 999;

      return aOrder - bOrder;
  });


  return groupedSuggestions;
}

function getActiveSite() {
  return (sessionStorage.getItem('activeSite') || 'main').toLowerCase();
}

function isOutletSite() {
  return getActiveSite() === 'outlet';
}

function isMainSite() {
  return getActiveSite() === 'main';
}

function getArabicProductUrl(url) {
  var parsedUrl = new URL(url);

  // Duplicate theme
  parsedUrl.host = 'ar.jashanmal.com';

  // Live theme
  // parsedUrl.host = window.location.host;

  return parsedUrl.toString();
}

(function () {
  var searchInput = document.querySelector(
    'search-form.search-modal__form input.search__input.field__input'
  );

  if (!searchInput) {
    return;
  }

  var filterSelector =
    '.wizzy-search-wrapper.has-filters-button-at-top .wizzy-filters-mobile-entry';

  var sortSelector =
    '.wizzy-search-wrapper .wizzy-search-results-wrapper .wizzy-search-results-container .wizzy-search-filters-top .search-filters-top-wrapper .wizzy-search-sort-wrapper .wizzy-sort-container';

  function positionMobileFilters() {
    var filterContainer = document.querySelector(filterSelector);
    var sortContainer = document.querySelector(sortSelector);

    if (!filterContainer && !sortContainer) {
      return;
    }

    var rect = searchInput.getBoundingClientRect();
    var topValue = rect.bottom + 25 + 'px';

    if (filterContainer) {
      filterContainer.style.top = topValue;
    }

    if (sortContainer) {
      sortContainer.style.top = topValue;
    }
  }

  // Initial position
  positionMobileFilters();

  // Reposition on scroll
  window.addEventListener('scroll', positionMobileFilters, {
    passive: true
  });

  // Reposition when viewport changes
  window.addEventListener('resize', positionMobileFilters);

  // Reposition when Wizzy creates/recreates the elements
  var wizzyMobileFiltersObserver = new MutationObserver(function () {
    positionMobileFilters();
  });

  wizzyMobileFiltersObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

// Keep the autocomplete wrapper attached with search bar
(function () {

  const searchInput = document.querySelector("search-form.search-modal__form input.search__input.field__input");
  if (!searchInput) return;

  function positionAutocomplete() {
    const autocomplete = document.querySelector(".wizzy-autocomplete-wrapper");
    if (!autocomplete) return;

    const rect = searchInput.getBoundingClientRect();

    autocomplete.style.top = rect.bottom + 14 + "px";
  }

  // Position on click
  searchInput.addEventListener("click", positionAutocomplete);

  // Reposition on scroll
  window.addEventListener("scroll", positionAutocomplete, { passive: true });

  // Reposition on DOM changes
  const wizzyAutocompleteAttachObserver = new MutationObserver(positionAutocomplete);

  wizzyAutocompleteAttachObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

function updateWizzyAutocompleteScroll() {
  var autocompleteWrapper = document.querySelector('.wizzy-autocomplete-wrapper');

  if (
    autocompleteWrapper &&
    window.getComputedStyle(autocompleteWrapper).display === 'flex'
  ) {
    document.body.classList.add('wizzy-autocomplete-open');
    document.documentElement.classList.add('wizzy-autocomplete-open');
  } else {
    document.body.classList.remove('wizzy-autocomplete-open');
    document.documentElement.classList.remove('wizzy-autocomplete-open');
  }
}

document.addEventListener(
  'touchmove',
  function (event) {
    if (
      document.body.classList.contains('wizzy-autocomplete-open') &&
      !event.target.closest('.wizzy-autocomplete-wrapper')
    ) {
      event.preventDefault();
    }
  },
  { passive: false }
);

(function () {
  if (window.innerWidth < 768) {
    var searchInput = document.querySelector(
      'search-form.search-modal__form input.search__input.field__input'
    );

    function updateWizzyAutocompleteHeight() {
      var autocomplete = document.querySelector(
        '.wizzy-autocomplete-wrapper'
      );

      if (
        autocomplete &&
        window.visualViewport &&
        window.getComputedStyle(autocomplete).display === 'flex'
      ) {
        var autocompleteTop = autocomplete.getBoundingClientRect().top;
        var viewportHeight = window.visualViewport.height;
        var availableHeight = viewportHeight - autocompleteTop;

        if (availableHeight > 0) {
          autocomplete.style.height = availableHeight + 'px';
          autocomplete.style.maxHeight = availableHeight + 'px';
        }
      }
    }

    function startAutocompleteHeightTracking() {
      updateWizzyAutocompleteHeight();

      var count = 0;
      var heightInterval = setInterval(function () {
        updateWizzyAutocompleteHeight();

        count++;

        // Keep checking for a short period while iOS keyboard opens/closes.
        if (count >= 20) {
          clearInterval(heightInterval);
        }
      }, 100);
    }

    if (searchInput) {
      searchInput.addEventListener(
        'focus',
        startAutocompleteHeightTracking
      );

      searchInput.addEventListener(
        'click',
        startAutocompleteHeightTracking
      );

      searchInput.addEventListener(
        'input',
        updateWizzyAutocompleteHeight
      );
    }

    if (window.visualViewport) {
      window.visualViewport.addEventListener(
        'resize',
        updateWizzyAutocompleteHeight
      );

      window.visualViewport.addEventListener(
        'scroll',
        updateWizzyAutocompleteHeight
      );
    }

    var wizzyAutocompleteHeightObserver = new MutationObserver(
      function () {
        updateWizzyAutocompleteHeight();
      }
    );

    wizzyAutocompleteHeightObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    updateWizzyAutocompleteHeight();
  }
})();


var wizzyAutocompleteObserver = new MutationObserver(function () {
  updateWizzyAutocompleteScroll();
});


wizzyAutocompleteObserver.observe(document.body, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ['style']
});


updateWizzyAutocompleteScroll();

// Prevent IOS scroll when quick add modal is opened
(function () {
  function updateQuickAddModalScrollLock() {
    var quickAddModal = document.querySelector(
      'quick-add-modal.quick-add-modal[open]'
    );

    if (
      document.body.classList.contains('wizzy-search-results-rendered') &&
      quickAddModal
    ) {
      document.documentElement.classList.add('wizzy-quick-add-modal-open');
      document.body.classList.add('wizzy-quick-add-modal-open');
    } else {
      document.documentElement.classList.remove('wizzy-quick-add-modal-open');
      document.body.classList.remove('wizzy-quick-add-modal-open');
    }
  }

  var wizzyQuickAddModalObserver = new MutationObserver(function () {
    updateQuickAddModalScrollLock();
  });

  wizzyQuickAddModalObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['open']
  });

  updateQuickAddModalScrollLock();
})();

function isArabicLocale() {
  var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
  if (lang.indexOf('ar') === 0) return true;
  if (window.Shopify && window.Shopify.locale && String(window.Shopify.locale).indexOf('ar') === 0) {
    return true;
  }
  return false;
}

var arabicTranslationMap = new Map();

function initializeArabicTranslationMap() {
  var translations = window.WizzyTranslations?.uiLabels;

  if (!translations) {
    return;
  }

  Object.keys(translations).forEach(function (key) {
    arabicTranslationMap.set(
      key.trim().toLowerCase(),
      translations[key]
    );
  });
}

function translateToArabic(label) {
  var normalizedLabel = String(label).trim().toLowerCase();

  // console.log("Wizzy arabic", label, normalizedLabel);

  return arabicTranslationMap.get(normalizedLabel) || label;
}

function translateColorsToArabic(label) {

  // console.log("Wizzy arabic", label, window.WizzyTranslations?.uiLabels?.[label])

  return (
    window.WizzyTranslations?.filterValues?.colors?.[label] ||
    label
  );
}

function translateFilterValueToArabic(type, value) {

  return (
    window.WizzyTranslations?.filterValues?.[type]?.[value] ||
    value
  );
}

function translateWizzyConfigToArabic(data) {
  configTranslationPaths.forEach(path => {
    translatePropertyToArabic(data, path);
  });

  if (data.autocomplete?.searchBar?.animatedPlaceholders?.length) {
    data.autocomplete.searchBar.animatedPlaceholders = data.autocomplete.searchBar.animatedPlaceholders.map(label => translateToArabic(label));
  }

  if (data.autocomplete?.configs?.defaultBehaviour?.suggestions?.defaultPool?.length) {
    data.autocomplete.configs.defaultBehaviour.suggestions.defaultPool =
      data.autocomplete.configs.defaultBehaviour.suggestions.defaultPool.map(suggestion => ({
        ...suggestion,
        value: suggestion.value ? translateToArabic(suggestion.value) : suggestion.value,
        valueHighlighted: suggestion.valueHighlighted
          ? translateToArabic(suggestion.valueHighlighted)
          : suggestion.valueHighlighted
      }));
  }

  if (data.search?.configs?.facets?.configs?.length) {
    data.search.configs.facets.configs =
      data.search.configs.facets.configs.map(facet => ({
        ...facet,
        label: facet.label ? translateToArabic(facet.label) : facet.label
      }));
  }

  if (data.search?.configs?.sorts?.configs?.length) {
    data.search.configs.sorts.configs =
      data.search.configs.sorts.configs.map(sort => ({
        ...sort,
        label: sort.label ? translateToArabic(sort.label) : sort.label
      }));
  }

  if (data.gridFilters?.filters?.length) {
    data.gridFilters.filters =
      data.gridFilters.filters.map(filter => ({
        ...filter,
        question: filter.question
          ? translateToArabic(filter.question)
          : filter.question
      }));
  }
}

function translatePropertyToArabic(obj, path) {
    const keys = path.split(".");
    let current = obj;

    for (let i = 0; i < keys.length - 1; i++) {
      current = current?.[keys[i]];

      if (!current) {
        // console.warn("Wizzy Missing path:", path);
        return;
      }
    }

    const lastKey = keys[keys.length - 1];

    // console.log("Wizzy Translating:", path, current[lastKey]);

    if (typeof current[lastKey] === "string") {
      current[lastKey] = translateToArabic(current[lastKey]);
    }
}

const configTranslationPaths = [
  "search.input.placeholder",
  "search.view.templates.literals.emptySearchResultPageTitle",
  "search.view.templates.literals.emptySearchResultPageSubTitle",
  "search.view.templates.literals.emptyCategoryPageTitle",
  "common.view.templates.literals.sortBy",
  "autocomplete.menu.categories.title",
  "autocomplete.menu.brands.title",
  "autocomplete.menu.others.title",
  "autocomplete.pages.title",
  "autocomplete.menu.categories.title",
  "autocomplete.menu.noResultsBehaviour",
  "autocomplete.recentSearches.title",
  "autocomplete.menu.noResultsText",
  "autocomplete.topProducts.title",
  "autocomplete.trendingSearches.title",
  "filters.view.templates.literals.gridLessButton",
  "filters.view.templates.literals.gridMoreButton"
];


// If using Wizzy events
// or another appropriate AFTER_* render event